var _path, _path2, _g, _path3, _path4, _g2, _path5, _path6, _g3, _path7, _path8, _g4, _path9, _path10, _g5, _path11, _path12, _g6, _path13, _path14, _g7, _path15, _path16, _g8, _path17, _path18, _g9, _path19, _path20, _g10, _path21, _path22, _g11, _path23, _path24, _g12, _path25, _path26, _g13, _path27, _path28, _g14, _path29, _path30, _g15, _path31, _path32, _g16, _path33, _path34, _g17, _path35, _path36, _g18, _path37, _path38, _g19, _path39, _path40, _g20, _path41, _path42, _g21, _path43, _path44, _g22, _path45, _path46, _g23, _path47, _path48, _g24, _path49, _path50, _g25, _path51, _path52, _g26, _path53, _path54, _g27, _path55, _path56, _g28, _path57, _path58, _g29, _path59, _path60, _g30, _path61, _path62, _g31, _path63, _path64, _g32, _path65, _path66, _g33, _path67, _path68, _g34, _path69, _path70, _g35, _path71, _path72, _g36, _path73, _path74, _g37, _path75, _path76, _g38, _path77, _path78, _g39, _path79, _path80, _g40, _path81, _path82, _g41, _path83, _path84, _g42, _path85, _path86, _g43, _path87, _path88, _g44, _path89, _path90, _g45, _path91, _path92, _g46, _path93, _path94, _g47, _path95, _path96, _g48, _path97, _path98, _g49, _path99, _path100, _g50, _path101, _path102, _g51, _path103, _path104, _g52, _path105, _path106, _g53, _path107, _path108, _g54, _path109, _path110, _g55, _path111, _path112, _g56, _path113, _path114, _g57, _path115, _path116, _g58, _path117, _path118, _g59, _path119, _path120, _g60, _path121, _path122, _g61, _path123, _path124, _g62, _path125, _path126, _g63, _path127, _path128, _g64, _path129, _path130, _g65, _path131, _path132, _g66, _path133, _path134, _g67, _path135, _path136, _g68, _path137, _path138, _g69, _path139, _path140, _g70, _path141, _path142, _g71, _path143, _path144, _path145, _path146, _path147, _g72, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _g73, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _g74, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _g75, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _g76, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _g77, _path188, _path189, _path190;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFlagLowHigh(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 375,
    height: 461,
    viewBox: "0 0 375 461",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.77015 362.827C0.923686 363.204 -0.922787 363.582 -2.77342 363.956C-2.87515 363.46 -2.97328 362.963 -3.07501 362.466C-1.22797 362.093 0.618498 361.715 2.46137 361.339C2.5631 361.835 2.66482 362.331 2.76655 362.828L2.77015 362.827Z",
    fill: "#723F19"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1781_645",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -4,
    y: 361,
    width: 7,
    height: 3
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.77015 362.827C0.923686 363.204 -0.922787 363.582 -2.77342 363.956C-2.87515 363.46 -2.97328 362.963 -3.07501 362.466C-1.22797 362.093 0.618498 361.715 2.46137 361.339C2.5631 361.835 2.66482 362.331 2.76655 362.828L2.77015 362.827Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1781_645)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-1.17223 363.751C-1.17223 363.751 -0.399266 363.073 -0.553324 361.837",
    stroke: "#583111",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.16048 363.482C0.16048 363.482 0.933434 362.805 0.775779 361.569",
    stroke: "#583111",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.49605 363.209C1.49605 363.209 2.26902 362.531 2.11136 361.295",
    stroke: "#583111",
    strokeMiterlimit: 10
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.31141 361.685C6.4661 362.069 4.62023 362.45 2.77377 362.827C2.67204 362.331 2.57029 361.834 2.46856 361.338C4.31502 360.961 6.15674 360.577 8.00263 360.196C8.10436 360.692 8.20968 361.188 8.31141 361.685Z",
    fill: "#723F19"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_1781_645",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 360,
    width: 7,
    height: 3
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.31141 361.685C6.4661 362.069 4.62023 362.45 2.77377 362.827C2.67204 362.331 2.57029 361.834 2.46856 361.338C4.31502 360.961 6.15674 360.577 8.00263 360.196C8.10436 360.692 8.20968 361.188 8.31141 361.685Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_1781_645)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.03133 362.893C3.03133 362.893 3.80428 362.216 3.64663 360.98",
    stroke: "#583111",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.36708 362.62C4.36708 362.62 5.13946 361.939 4.97878 360.707",
    stroke: "#583111",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.70226 362.343C5.70226 362.343 6.47463 361.662 6.31338 360.427",
    stroke: "#583111",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.03367 362.067C7.03367 362.067 7.80607 361.386 7.64482 360.15",
    stroke: "#583111",
    strokeMiterlimit: 10
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M13.8427 360.525C11.998 360.913 10.1533 361.301 8.30736 361.682C8.20563 361.185 8.10031 360.69 7.99858 360.193C9.84389 359.809 11.6856 359.425 13.5303 359.037C13.6357 359.533 13.7374 360.029 13.8427 360.525Z",
    fill: "#723F19"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_1781_645",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 7,
    y: 359,
    width: 7,
    height: 3
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M13.8427 360.525C11.998 360.913 10.1533 361.301 8.30736 361.682C8.20563 361.185 8.10031 360.69 7.99858 360.193C9.84389 359.809 11.6856 359.425 13.5303 359.037C13.6357 359.533 13.7374 360.029 13.8427 360.525Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_1781_645)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.5728 361.749C8.5728 361.749 9.34517 361.069 9.18032 359.834",
    stroke: "#583111",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.90367 361.47C9.90367 361.47 10.6724 360.79 10.5112 359.554",
    stroke: "#583111",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.2388 361.193C11.2388 361.193 12.0075 360.513 11.8463 359.277",
    stroke: "#583111",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.5697 360.913C12.5697 360.913 13.3385 360.233 13.1736 358.998",
    stroke: "#583111",
    strokeMiterlimit: 10
  }))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M19.3756 359.353C17.5315 359.745 15.6873 360.136 13.8462 360.524C13.7408 360.028 13.6391 359.531 13.5338 359.036C15.3785 358.648 17.2191 358.257 19.0597 357.866C19.165 358.361 19.2703 358.857 19.375 359.349L19.3756 359.353Z",
    fill: "#723F19"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_1781_645",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 13,
    y: 357,
    width: 7,
    height: 4
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M19.3756 359.353C17.5315 359.745 15.6873 360.136 13.8462 360.524C13.7408 360.028 13.6391 359.531 13.5338 359.036C15.3785 358.648 17.2191 358.257 19.0597 357.866C19.165 358.361 19.2703 358.857 19.375 359.349L19.3756 359.353Z",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_1781_645)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.104 360.589C14.104 360.589 14.8721 359.905 14.7073 358.67",
    stroke: "#583111",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.4385 360.309C15.4385 360.309 16.2067 359.625 16.0418 358.39",
    stroke: "#583111",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.7689 360.025C16.7689 360.025 17.5371 359.342 17.3687 358.107",
    stroke: "#583111",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.1029 359.741C18.1029 359.741 18.8711 359.057 18.7027 357.823",
    stroke: "#583111",
    strokeMiterlimit: 10
  }))), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M24.9027 358.168C23.0597 358.567 21.2197 358.962 19.3756 359.353C19.2703 358.857 19.1649 358.362 19.0602 357.869C20.9008 357.478 22.7438 357.08 24.5837 356.685C24.6891 357.181 24.798 357.676 24.9027 358.168Z",
    fill: "#723F19"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask4_1781_645",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 19,
    y: 356,
    width: 6,
    height: 4
  }, _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M24.9027 358.168C23.0597 358.567 21.2197 358.962 19.3756 359.353C19.2703 358.857 19.1649 358.362 19.0602 357.869C20.9008 357.478 22.7438 357.08 24.5837 356.685C24.6891 357.181 24.798 357.676 24.9027 358.168Z",
    fill: "white"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4_1781_645)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.6369 359.418C19.6369 359.418 20.4051 358.734 20.2367 357.5",
    stroke: "#583111",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.9667 359.131C20.9667 359.131 21.7313 358.448 21.5629 357.213",
    stroke: "#583111",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.3007 358.847C22.3007 358.847 23.0684 358.159 22.8969 356.929",
    stroke: "#583111",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.6305 358.56C23.6305 358.56 24.3945 357.873 24.2261 356.639",
    stroke: "#583111",
    strokeMiterlimit: 10
  }))), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M30.4271 356.965C28.5883 357.367 26.7459 357.77 24.9023 358.165C24.797 357.669 24.6881 357.174 24.5833 356.682C26.4227 356.283 28.2621 355.885 30.1046 355.483C30.2135 355.978 30.3224 356.473 30.4271 356.965Z",
    fill: "#723F19"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask5_1781_645",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 24,
    y: 355,
    width: 7,
    height: 4
  }, _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M30.4271 356.965C28.5883 357.367 26.7459 357.77 24.9023 358.165C24.797 357.669 24.6881 357.174 24.5833 356.682C26.4227 356.283 28.2621 355.885 30.1046 355.483C30.2135 355.978 30.3224 356.473 30.4271 356.965Z",
    fill: "white"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask5_1781_645)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.1636 358.23C25.1636 358.23 25.9276 357.543 25.7555 356.309",
    stroke: "#583111",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.497 357.942C26.497 357.942 27.261 357.255 27.089 356.021",
    stroke: "#583111",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.8263 357.651C27.8263 357.651 28.5903 356.964 28.4183 355.73",
    stroke: "#583111",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.156 357.365C29.156 357.365 29.92 356.678 29.7444 355.445",
    stroke: "#583111",
    strokeMiterlimit: 10
  }))), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M35.9461 355.752C34.1078 356.157 32.266 356.563 30.4271 356.965C30.3182 356.47 30.2093 355.974 30.1045 355.482C31.9434 355.08 33.7816 354.675 35.6199 354.269C35.7288 354.765 35.8377 355.26 35.9497 355.751L35.9461 355.752Z",
    fill: "#723F19"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask6_1781_645",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 30,
    y: 354,
    width: 6,
    height: 3
  }, _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M35.9461 355.752C34.1078 356.157 32.266 356.563 30.4271 356.965C30.3182 356.47 30.2093 355.974 30.1045 355.482C31.9434 355.08 33.7816 354.675 35.6199 354.269C35.7288 354.765 35.8377 355.26 35.9497 355.751L35.9461 355.752Z",
    fill: "white"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask6_1781_645)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.6879 357.026C30.6879 357.026 31.4514 356.336 31.2763 355.106",
    stroke: "#583111",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.017 356.736C32.017 356.736 32.7805 356.045 32.6049 354.812",
    stroke: "#583111",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.3463 356.446C33.3463 356.446 34.1062 355.756 33.9305 354.523",
    stroke: "#583111",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.6785 356.151C34.6785 356.151 35.4383 355.461 35.2627 354.228",
    stroke: "#583111",
    strokeMiterlimit: 10
  }))), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M41.4627 354.524C39.6256 354.936 37.7843 355.346 35.946 355.752C35.8371 355.256 35.7282 354.761 35.6163 354.27C37.4545 353.865 39.2916 353.452 41.1293 353.043C41.2418 353.538 41.3502 354.029 41.4627 354.524Z",
    fill: "#723F19"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask7_1781_645",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 35,
    y: 353,
    width: 7,
    height: 3
  }, _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M41.4627 354.524C39.6256 354.936 37.7843 355.346 35.946 355.752C35.8371 355.256 35.7282 354.761 35.6163 354.27C37.4545 353.865 39.2916 353.452 41.1293 353.043C41.2418 353.538 41.3502 354.029 41.4627 354.524Z",
    fill: "white"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask7_1781_645)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M36.2069 355.813C36.2069 355.813 36.9667 355.123 36.7911 353.89",
    stroke: "#583111",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.539 355.518C37.539 355.518 38.2989 354.828 38.1196 353.595",
    stroke: "#583111",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.8671 355.221C38.8671 355.221 39.627 354.531 39.4478 353.299",
    stroke: "#583111",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.1957 354.927C40.1957 354.927 40.955 354.233 40.7758 353.001",
    stroke: "#583111",
    strokeMiterlimit: 10
  }))), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M46.9729 353.279C45.1363 353.695 43.2998 354.111 41.4621 354.52C41.3496 354.026 41.2413 353.534 41.1288 353.039C42.9659 352.627 44.8029 352.214 46.6359 351.798C46.7484 352.293 46.8603 352.784 46.9729 353.279Z",
    fill: "#723F19"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask8_1781_645",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 41,
    y: 351,
    width: 6,
    height: 4
  }, _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M46.9729 353.279C45.1363 353.695 43.2998 354.111 41.4621 354.52C41.3496 354.026 41.2413 353.534 41.1288 353.039C42.9659 352.627 44.8029 352.214 46.6359 351.798C46.7484 352.293 46.8603 352.784 46.9729 353.279Z",
    fill: "white"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask8_1781_645)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M41.7227 354.582C41.7227 354.582 42.482 353.889 42.2991 352.657",
    stroke: "#583111",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.0507 354.284C43.0507 354.284 43.81 353.591 43.6272 352.359",
    stroke: "#583111",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.3788 353.986C44.3788 353.986 45.1345 353.294 44.9553 352.061",
    stroke: "#583111",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.7063 353.685C45.7063 353.685 46.4655 352.991 46.2827 351.759",
    stroke: "#583111",
    strokeMiterlimit: 10
  }))), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M52.4849 352.022C50.649 352.442 48.813 352.862 46.9765 353.278C46.864 352.784 46.7521 352.292 46.6395 351.798C48.4761 351.382 50.3084 350.962 52.1444 350.543C52.2569 351.037 52.3724 351.528 52.4849 352.022Z",
    fill: "#723F19"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask9_1781_645",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 46,
    y: 350,
    width: 7,
    height: 4
  }, _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M52.4849 352.022C50.649 352.442 48.813 352.862 46.9765 353.278C46.864 352.784 46.7521 352.292 46.6395 351.798C48.4761 351.382 50.3084 350.962 52.1444 350.543C52.2569 351.037 52.3724 351.528 52.4849 352.022Z",
    fill: "white"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask9_1781_645)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M47.237 353.339C47.237 353.339 47.9963 352.646 47.8098 351.414",
    stroke: "#583111",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.5645 353.038C48.5645 353.038 49.3202 352.345 49.1374 351.113",
    stroke: "#583111",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.8914 352.733C49.8914 352.733 50.6465 352.037 50.4636 350.805",
    stroke: "#583111",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.2189 352.431C51.2189 352.431 51.974 351.735 51.7876 350.503",
    stroke: "#583111",
    strokeMiterlimit: 10
  }))), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M57.9868 350.749C56.152 351.176 54.3166 351.6 52.4806 352.02C52.3681 351.525 52.2526 351.034 52.1401 350.54C53.976 350.12 55.8072 349.693 57.6426 349.27C57.7587 349.764 57.8707 350.255 57.9868 350.749Z",
    fill: "#723F19"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask10_1781_645",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 52,
    y: 349,
    width: 6,
    height: 4
  }, _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M57.9868 350.749C56.152 351.176 54.3166 351.6 52.4806 352.02C52.3681 351.525 52.2526 351.034 52.1401 350.54C53.976 350.12 55.8072 349.693 57.6426 349.27C57.7587 349.764 57.8707 350.255 57.9868 350.749Z",
    fill: "white"
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask10_1781_645)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M52.7449 352.081C52.7449 352.081 53.5 351.384 53.3136 350.153",
    stroke: "#583111",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.0719 351.776C54.0719 351.776 54.827 351.08 54.6406 349.848",
    stroke: "#583111",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.3987 351.471C55.3987 351.471 56.1538 350.774 55.9638 349.543",
    stroke: "#583111",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.7252 351.162C56.7252 351.162 57.4803 350.465 57.2902 349.234",
    stroke: "#583111",
    strokeMiterlimit: 10
  }))), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M63.4906 349.465C61.6564 349.896 59.8258 350.326 57.9904 350.749C57.8743 350.255 57.7623 349.764 57.6462 349.27C59.4774 348.843 61.3122 348.416 63.1429 347.986C63.259 348.481 63.3745 348.971 63.4906 349.465Z",
    fill: "#723F19"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask11_1781_645",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 57,
    y: 347,
    width: 7,
    height: 4
  }, _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M63.4906 349.465C61.6564 349.896 59.8258 350.326 57.9904 350.749C57.8743 350.255 57.7623 349.764 57.6462 349.27C59.4774 348.843 61.3122 348.416 63.1429 347.986C63.259 348.481 63.3745 348.971 63.4906 349.465Z",
    fill: "white"
  }))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask11_1781_645)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M58.2511 350.811C58.2511 350.811 59.0063 350.115 58.8157 348.88",
    stroke: "#583111",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.5774 350.502C59.5774 350.502 60.3284 349.803 60.1383 348.572",
    stroke: "#583111",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.9032 350.19C60.9032 350.19 61.6542 349.49 61.4641 348.259",
    stroke: "#583111",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.2259 349.882C62.2259 349.882 62.9768 349.183 62.7868 347.952",
    stroke: "#583111",
    strokeMiterlimit: 10
  }))), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M68.9885 348.167C67.1549 348.601 65.3248 349.034 63.4906 349.465C63.3745 348.971 63.259 348.481 63.1429 347.986C64.9735 347.556 66.8071 347.122 68.6372 346.689C68.7533 347.183 68.8724 347.673 68.9885 348.167Z",
    fill: "#723F19"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask12_1781_645",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 63,
    y: 346,
    width: 6,
    height: 4
  }, _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M68.9885 348.167C67.1549 348.601 65.3248 349.034 63.4906 349.465C63.3745 348.971 63.259 348.481 63.1429 347.986C64.9735 347.556 66.8071 347.122 68.6372 346.689C68.7533 347.183 68.8724 347.673 68.9885 348.167Z",
    fill: "white"
  }))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask12_1781_645)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M63.7506 349.523C63.7506 349.523 64.5015 348.823 64.3079 347.593",
    stroke: "#583111",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.0764 349.21C65.0764 349.21 65.8273 348.511 65.6337 347.281",
    stroke: "#583111",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.4021 348.898C66.4021 348.898 67.153 348.198 66.9594 346.968",
    stroke: "#583111",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.7236 348.583C67.7236 348.583 68.474 347.88 68.2768 346.65",
    stroke: "#583111",
    strokeMiterlimit: 10
  }))), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M74.4799 346.85C72.651 347.291 70.8179 347.729 68.9879 348.162C68.8717 347.668 68.7526 347.178 68.6365 346.684C70.4665 346.251 72.2954 345.81 74.1249 345.373C74.2446 345.866 74.3602 346.357 74.4799 346.85Z",
    fill: "#723F19"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask13_1781_645",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 68,
    y: 345,
    width: 7,
    height: 4
  }, _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M74.4799 346.85C72.651 347.291 70.8179 347.729 68.9879 348.162C68.8717 347.668 68.7526 347.178 68.6365 346.684C70.4665 346.251 72.2954 345.81 74.1249 345.373C74.2446 345.866 74.3602 346.357 74.4799 346.85Z",
    fill: "white"
  }))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask13_1781_645)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M69.2479 348.22C69.2479 348.22 69.9983 347.517 69.8011 346.287",
    stroke: "#583111",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.5732 347.904C70.5732 347.904 71.3235 347.201 71.1263 345.972",
    stroke: "#583111",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.8947 347.589C71.8947 347.589 72.6451 346.886 72.4443 345.657",
    stroke: "#583111",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.2198 347.274C73.2198 347.274 73.9701 346.57 73.7693 345.341",
    stroke: "#583111",
    strokeMiterlimit: 10
  }))), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M79.9697 345.523C78.1414 345.968 76.3094 346.413 74.48 346.85C74.3603 346.357 74.2447 345.866 74.125 345.373C75.9539 344.932 77.7828 344.491 79.6111 344.047C79.7308 344.54 79.85 345.03 79.9697 345.523Z",
    fill: "#723F19"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask14_1781_645",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 74,
    y: 344,
    width: 6,
    height: 3
  }, _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M79.9697 345.523C78.1414 345.968 76.3094 346.413 74.48 346.85C74.3603 346.357 74.2447 345.866 74.125 345.373C75.9539 344.932 77.7828 344.491 79.6111 344.047C79.7308 344.54 79.85 345.03 79.9697 345.523Z",
    fill: "white"
  }))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask14_1781_645)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M74.7435 346.907C74.7435 346.907 75.4903 346.205 75.2931 344.975",
    stroke: "#583111",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.0645 346.588C76.0645 346.588 76.8107 345.882 76.6105 344.656",
    stroke: "#583111",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.3892 346.269C77.3892 346.269 78.1354 345.563 77.9346 344.334",
    stroke: "#583111",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.7096 345.946C78.7096 345.946 79.4557 345.24 79.2549 344.011",
    stroke: "#583111",
    strokeMiterlimit: 10
  }))), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M85.4564 344.179C83.6287 344.627 81.8009 345.075 79.969 345.52C79.8493 345.027 79.7302 344.537 79.6105 344.043C81.4388 343.599 83.2665 343.151 85.0943 342.703C85.214 343.196 85.3367 343.686 85.4564 344.179Z",
    fill: "#723F19"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask15_1781_645",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 79,
    y: 342,
    width: 7,
    height: 4
  }, _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M85.4564 344.179C83.6287 344.627 81.8009 345.075 79.969 345.52C79.8493 345.027 79.7302 344.537 79.6105 344.043C81.4388 343.599 83.2665 343.151 85.0943 342.703C85.214 343.196 85.3367 343.686 85.4564 344.179Z",
    fill: "white"
  }))), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask15_1781_645)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M80.2328 345.577C80.2328 345.577 80.979 344.871 80.7746 343.642",
    stroke: "#583111",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.5532 345.255C81.5532 345.255 82.2994 344.549 82.095 343.32",
    stroke: "#583111",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.8773 344.932C82.8773 344.932 83.6235 344.226 83.4191 342.998",
    stroke: "#583111",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.1977 344.61C84.1977 344.61 84.9439 343.904 84.7359 342.676",
    stroke: "#583111",
    strokeMiterlimit: 10
  }))), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M90.938 342.825C89.1114 343.28 87.2842 343.731 85.4565 344.179C85.3368 343.686 85.2141 343.197 85.0943 342.703C86.9221 342.255 88.7451 341.801 90.5722 341.349C90.6955 341.842 90.8183 342.331 90.938 342.825Z",
    fill: "#723F19"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask16_1781_645",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 85,
    y: 341,
    width: 6,
    height: 4
  }, _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M90.938 342.825C89.1114 343.28 87.2842 343.731 85.4565 344.179C85.3368 343.686 85.2141 343.197 85.0943 342.703C86.9221 342.255 88.7451 341.801 90.5722 341.349C90.6955 341.842 90.8183 342.331 90.938 342.825Z",
    fill: "white"
  }))), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask16_1781_645)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M85.7203 344.237C85.7203 344.237 86.4659 343.527 86.2579 342.299",
    stroke: "#583111",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.04 343.911C87.04 343.911 87.782 343.202 87.5776 341.973",
    stroke: "#583111",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.3598 343.584C88.3598 343.584 89.1019 342.875 88.8939 341.647",
    stroke: "#583111",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.6791 343.255C89.6791 343.255 90.4211 342.546 90.2131 341.318",
    stroke: "#583111",
    strokeMiterlimit: 10
  }))), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M96.4171 341.455C94.5911 341.914 92.7651 342.373 90.9379 342.824C90.8146 342.331 90.6919 341.842 90.5722 341.348C92.3988 340.893 94.2218 340.439 96.0478 339.98C96.1705 340.469 96.2938 340.962 96.4165 341.451L96.4171 341.455Z",
    fill: "#723F19"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask17_1781_645",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 90,
    y: 339,
    width: 7,
    height: 4
  }, _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M96.4171 341.455C94.5911 341.914 92.7651 342.373 90.9379 342.824C90.8146 342.331 90.6919 341.842 90.5722 341.348C92.3988 340.893 94.2218 340.439 96.0478 339.98C96.1705 340.469 96.2938 340.962 96.4165 341.451L96.4171 341.455Z",
    fill: "white"
  }))), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask17_1781_645)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M91.201 342.877C91.201 342.877 91.943 342.168 91.735 340.94",
    stroke: "#583111",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.5202 342.548C92.5202 342.548 93.2622 341.839 93.0506 340.612",
    stroke: "#583111",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.8395 342.218C93.8395 342.218 94.5815 341.509 94.3699 340.282",
    stroke: "#583111",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.1587 341.889C95.1587 341.889 95.9002 341.176 95.6886 339.949",
    stroke: "#583111",
    strokeMiterlimit: 10
  }))), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M101.89 340.069C100.064 340.531 98.2426 340.993 96.4166 341.452C96.2938 340.962 96.1705 340.469 96.0478 339.98C97.8702 339.522 99.6957 339.059 101.517 338.598C101.644 339.086 101.767 339.579 101.89 340.069Z",
    fill: "#723F19"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask18_1781_645",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 96,
    y: 338,
    width: 6,
    height: 4
  }, _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M101.89 340.069C100.064 340.531 98.2426 340.993 96.4166 341.452C96.2938 340.962 96.1705 340.469 96.0478 339.98C97.8702 339.522 99.6957 339.059 101.517 338.598C101.644 339.086 101.767 339.579 101.89 340.069Z",
    fill: "white"
  }))), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask18_1781_645)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M96.6803 341.508C96.6803 341.508 97.4217 340.795 97.2065 339.568",
    stroke: "#583111",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.999 341.175C97.999 341.175 98.7368 340.463 98.5252 339.235",
    stroke: "#583111",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.3176 340.842C99.3176 340.842 100.055 340.13 99.8439 338.902",
    stroke: "#583111",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.636 340.509C100.636 340.509 101.374 339.797 101.159 338.57",
    stroke: "#583111",
    strokeMiterlimit: 10
  }))), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M107.357 338.672C105.536 339.141 103.712 339.607 101.886 340.07C101.76 339.581 101.637 339.088 101.514 338.599C103.336 338.137 105.16 337.671 106.981 337.202C107.107 337.691 107.234 338.183 107.361 338.672L107.357 338.672Z",
    fill: "#723F19"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask19_1781_645",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 101,
    y: 337,
    width: 7,
    height: 4
  }, _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M107.357 338.672C105.536 339.141 103.712 339.607 101.886 340.07C101.76 339.581 101.637 339.088 101.514 338.599C103.336 338.137 105.16 337.671 106.981 337.202C107.107 337.691 107.234 338.183 107.361 338.672L107.357 338.672Z",
    fill: "white"
  }))), _g20 || (_g20 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask19_1781_645)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M102.153 340.122C102.153 340.122 102.891 339.41 102.676 338.183",
    stroke: "#583111",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.471 339.785C103.471 339.785 104.208 339.07 103.994 337.846",
    stroke: "#583111",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.789 339.449C104.789 339.449 105.526 338.733 105.308 337.507",
    stroke: "#583111",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.104 339.113C106.104 339.113 106.841 338.397 106.622 337.171",
    stroke: "#583111",
    strokeMiterlimit: 10
  }))), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M112.826 337.26C111.006 337.732 109.182 338.206 107.361 338.671C107.234 338.182 107.107 337.69 106.981 337.201C108.802 336.732 110.622 336.263 112.443 335.791C112.569 336.279 112.696 336.772 112.826 337.26Z",
    fill: "#723F19"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask20_1781_645",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 106,
    y: 335,
    width: 7,
    height: 4
  }, _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M112.826 337.26C111.006 337.732 109.182 338.206 107.361 338.671C107.234 338.182 107.107 337.69 106.981 337.201C108.802 336.732 110.622 336.263 112.443 335.791C112.569 336.279 112.696 336.772 112.826 337.26Z",
    fill: "white"
  }))), _g21 || (_g21 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask20_1781_645)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M107.624 338.725C107.624 338.725 108.361 338.01 108.142 336.783",
    stroke: "#583111",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.938 338.386C108.938 338.386 109.675 337.67 109.453 336.444",
    stroke: "#583111",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.255 338.045C110.255 338.045 110.993 337.329 110.77 336.103",
    stroke: "#583111",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.573 337.705C111.573 337.705 112.31 336.989 112.088 335.763",
    stroke: "#583111",
    strokeMiterlimit: 10
  }))), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M118.284 335.831C116.465 336.308 114.645 336.784 112.822 337.257C112.695 336.768 112.568 336.276 112.438 335.788C114.259 335.315 116.078 334.839 117.898 334.363C118.028 334.851 118.154 335.343 118.284 335.831Z",
    fill: "#723F19"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask21_1781_645",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 112,
    y: 334,
    width: 7,
    height: 4
  }, _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M118.284 335.831C116.465 336.308 114.645 336.784 112.822 337.257C112.695 336.768 112.568 336.276 112.438 335.788C114.259 335.315 116.078 334.839 117.898 334.363C118.028 334.851 118.154 335.343 118.284 335.831Z",
    fill: "white"
  }))), _g22 || (_g22 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask21_1781_645)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M113.088 337.309C113.088 337.309 113.821 336.591 113.6 335.368",
    stroke: "#583111",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.405 336.966C114.405 336.966 115.138 336.248 114.916 335.022",
    stroke: "#583111",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.719 336.627C115.719 336.627 116.452 335.908 116.23 334.682",
    stroke: "#583111",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.036 336.279C117.036 336.279 117.769 335.56 117.543 334.335",
    stroke: "#583111",
    strokeMiterlimit: 10
  }))), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M123.745 334.392C121.926 334.875 120.108 335.355 118.288 335.831C118.158 335.343 118.031 334.851 117.901 334.363C119.721 333.887 121.54 333.407 123.355 332.924C123.484 333.412 123.615 333.904 123.745 334.392Z",
    fill: "#723F19"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask22_1781_645",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 117,
    y: 332,
    width: 7,
    height: 4
  }, _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M123.745 334.392C121.926 334.875 120.108 335.355 118.288 335.831C118.158 335.343 118.031 334.851 117.901 334.363C119.721 333.887 121.54 333.407 123.355 332.924C123.484 333.412 123.615 333.904 123.745 334.392Z",
    fill: "white"
  }))), _g23 || (_g23 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask22_1781_645)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M118.551 335.885C118.551 335.885 119.284 335.167 119.058 333.941",
    stroke: "#583111",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.864 335.539C119.864 335.539 120.597 334.82 120.371 333.595",
    stroke: "#583111",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.18 335.191C121.18 335.191 121.914 334.472 121.684 333.248",
    stroke: "#583111",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.493 334.843C122.493 334.843 123.222 334.122 122.997 332.9",
    stroke: "#583111",
    strokeMiterlimit: 10
  }))), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M129.196 332.938C127.378 333.425 125.56 333.912 123.741 334.392C123.611 333.904 123.481 333.412 123.351 332.924C125.169 332.441 126.984 331.958 128.802 331.471C128.932 331.959 129.066 332.45 129.196 332.938Z",
    fill: "#723F19"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask23_1781_645",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 123,
    y: 331,
    width: 7,
    height: 4
  }, _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M129.196 332.938C127.378 333.425 125.56 333.912 123.741 334.392C123.611 333.904 123.481 333.412 123.351 332.924C125.169 332.441 126.984 331.958 128.802 331.471C128.932 331.959 129.066 332.45 129.196 332.938Z",
    fill: "white"
  }))), _g24 || (_g24 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask23_1781_645)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M124.007 334.442C124.007 334.442 124.736 333.72 124.51 332.495",
    stroke: "#583111",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.32 334.095C125.32 334.095 126.049 333.373 125.82 332.149",
    stroke: "#583111",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.636 333.743C126.636 333.743 127.365 333.022 127.135 331.797",
    stroke: "#583111",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.948 333.393C127.948 333.393 128.677 332.671 128.448 331.446",
    stroke: "#583111",
    strokeMiterlimit: 10
  }))), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M134.648 331.471C132.831 331.961 131.017 332.451 129.2 332.938C129.07 332.45 128.935 331.959 128.806 331.471C130.62 330.984 132.437 330.494 134.251 330.004C134.384 330.491 134.514 330.979 134.648 331.471Z",
    fill: "#723F19"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask24_1781_645",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 128,
    y: 330,
    width: 7,
    height: 3
  }, _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M134.648 331.471C132.831 331.961 131.017 332.451 129.2 332.938C129.07 332.45 128.935 331.959 128.806 331.471C130.62 330.984 132.437 330.494 134.251 330.004C134.384 330.491 134.514 330.979 134.648 331.471Z",
    fill: "white"
  }))), _g25 || (_g25 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask24_1781_645)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M129.462 332.989C129.462 332.989 130.191 332.267 129.958 331.043",
    stroke: "#583111",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.774 332.634C130.774 332.634 131.503 331.912 131.269 330.688",
    stroke: "#583111",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.085 332.28C132.085 332.28 132.814 331.554 132.581 330.334",
    stroke: "#583111",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.4 331.925C133.4 331.925 134.129 331.199 133.892 329.976",
    stroke: "#583111",
    strokeMiterlimit: 10
  }))), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M140.09 329.986C138.278 330.483 136.461 330.977 134.644 331.468C134.51 330.98 134.38 330.492 134.246 330.001C136.06 329.511 137.877 329.016 139.689 328.519C139.823 329.007 139.956 329.494 140.09 329.986Z",
    fill: "#723F19"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask25_1781_645",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 134,
    y: 328,
    width: 7,
    height: 4
  }, _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M140.09 329.986C138.278 330.483 136.461 330.977 134.644 331.468C134.51 330.98 134.38 330.492 134.246 330.001C136.06 329.511 137.877 329.016 139.689 328.519C139.823 329.007 139.956 329.494 140.09 329.986Z",
    fill: "white"
  }))), _g26 || (_g26 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask25_1781_645)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M134.91 331.517C134.91 331.517 135.638 330.791 135.402 329.568",
    stroke: "#583111",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.222 331.163C136.222 331.163 136.946 330.438 136.713 329.214",
    stroke: "#583111",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.533 330.805C137.533 330.805 138.258 330.08 138.021 328.856",
    stroke: "#583111",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.847 330.446C138.847 330.446 139.572 329.721 139.335 328.498",
    stroke: "#583111",
    strokeMiterlimit: 10
  }))), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M145.531 328.489C143.719 328.99 141.903 329.488 140.09 329.985C139.957 329.498 139.823 329.01 139.689 328.519C141.502 328.022 143.314 327.524 145.126 327.024C145.26 327.511 145.397 327.998 145.53 328.486L145.531 328.489Z",
    fill: "#723F19"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask26_1781_645",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 139,
    y: 327,
    width: 7,
    height: 3
  }, _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M145.531 328.489C143.719 328.99 141.903 329.488 140.09 329.985C139.957 329.498 139.823 329.01 139.689 328.519C141.502 328.022 143.314 327.524 145.126 327.024C145.26 327.511 145.397 327.998 145.53 328.486L145.531 328.489Z",
    fill: "white"
  }))), _g27 || (_g27 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask26_1781_645)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M140.356 330.035C140.356 330.035 141.081 329.31 140.844 328.087",
    stroke: "#583111",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.667 329.674C141.667 329.674 142.391 328.945 142.151 327.726",
    stroke: "#583111",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.978 329.316C142.978 329.316 143.702 328.588 143.462 327.365",
    stroke: "#583111",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.288 328.955C144.288 328.955 145.013 328.226 144.772 327.003",
    stroke: "#583111",
    strokeMiterlimit: 10
  }))), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M150.969 326.979C149.158 327.484 147.346 327.988 145.531 328.49C145.397 328.002 145.26 327.515 145.127 327.027C146.939 326.527 148.75 326.022 150.561 325.518C150.698 326.005 150.832 326.492 150.969 326.979Z",
    fill: "#723F19"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask27_1781_645",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 145,
    y: 325,
    width: 6,
    height: 4
  }, _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M150.969 326.979C149.158 327.484 147.346 327.988 145.531 328.49C145.397 328.002 145.26 327.515 145.127 327.027C146.939 326.527 148.75 326.022 150.561 325.518C150.698 326.005 150.832 326.492 150.969 326.979Z",
    fill: "white"
  }))), _g28 || (_g28 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask27_1781_645)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M145.796 328.536C145.796 328.536 146.52 327.807 146.276 326.585",
    stroke: "#583111",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.107 328.174C147.107 328.174 147.831 327.446 147.587 326.224",
    stroke: "#583111",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.417 327.809C148.417 327.809 149.137 327.081 148.897 325.858",
    stroke: "#583111",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.727 327.448C149.727 327.448 150.451 326.719 150.204 325.498",
    stroke: "#583111",
    strokeMiterlimit: 10
  }))), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M156.401 325.456C154.591 325.968 152.78 326.476 150.969 326.98C150.832 326.493 150.698 326.005 150.561 325.518C152.372 325.014 154.18 324.507 155.99 323.995C156.127 324.482 156.264 324.969 156.401 325.456Z",
    fill: "#723F19"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask28_1781_645",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 150,
    y: 323,
    width: 7,
    height: 4
  }, _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M156.401 325.456C154.591 325.968 152.78 326.476 150.969 326.98C150.832 326.493 150.698 326.005 150.561 325.518C152.372 325.014 154.18 324.507 155.99 323.995C156.127 324.482 156.264 324.969 156.401 325.456Z",
    fill: "white"
  }))), _g29 || (_g29 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask28_1781_645)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M151.234 327.026C151.234 327.026 151.954 326.295 151.711 325.076",
    stroke: "#583111",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.544 326.661C152.544 326.661 153.264 325.93 153.02 324.708",
    stroke: "#583111",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.85 326.293C153.85 326.293 154.57 325.562 154.322 324.34",
    stroke: "#583111",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.159 325.924C155.159 325.924 155.879 325.193 155.632 323.971",
    stroke: "#583111",
    strokeMiterlimit: 10
  }))), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M161.831 323.917C160.021 324.433 158.211 324.944 156.401 325.456C156.264 324.969 156.127 324.482 155.99 323.995C157.8 323.483 159.606 322.972 161.412 322.457C161.55 322.944 161.69 323.431 161.827 323.918L161.831 323.917Z",
    fill: "#723F19"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask29_1781_645",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 155,
    y: 322,
    width: 7,
    height: 4
  }, _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M161.831 323.917C160.021 324.433 158.211 324.944 156.401 325.456C156.264 324.969 156.127 324.482 155.99 323.995C157.8 323.483 159.606 322.972 161.412 322.457C161.55 322.944 161.69 323.431 161.827 323.918L161.831 323.917Z",
    fill: "white"
  }))), _g30 || (_g30 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask29_1781_645)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M156.667 325.501C156.667 325.501 157.387 324.77 157.139 323.548",
    stroke: "#583111",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.975 325.129C157.975 325.129 158.695 324.398 158.444 323.177",
    stroke: "#583111",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.281 324.761C159.281 324.761 159.998 324.03 159.75 322.808",
    stroke: "#583111",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.59 324.389C160.59 324.389 161.306 323.655 161.059 322.436",
    stroke: "#583111",
    strokeMiterlimit: 10
  }))), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M167.255 322.365C165.446 322.883 163.641 323.402 161.831 323.917C161.694 323.43 161.553 322.943 161.416 322.456C163.222 321.942 165.031 321.423 166.836 320.905C166.977 321.391 167.118 321.878 167.255 322.365Z",
    fill: "#723F19"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask30_1781_645",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 161,
    y: 320,
    width: 7,
    height: 4
  }, _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M167.255 322.365C165.446 322.883 163.641 323.402 161.831 323.917C161.694 323.43 161.553 322.943 161.416 322.456C163.222 321.942 165.031 321.423 166.836 320.905C166.977 321.391 167.118 321.878 167.255 322.365Z",
    fill: "white"
  }))), _g31 || (_g31 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask30_1781_645)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M162.096 323.958C162.096 323.958 162.812 323.224 162.561 322.006",
    stroke: "#583111",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.401 323.587C163.401 323.587 164.117 322.852 163.866 321.631",
    stroke: "#583111",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.71 323.215C164.71 323.215 165.426 322.48 165.175 321.259",
    stroke: "#583111",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.014 322.84C166.014 322.84 166.73 322.105 166.476 320.885",
    stroke: "#583111",
    strokeMiterlimit: 10
  }))), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M172.673 320.799C170.869 321.325 169.06 321.847 167.255 322.365C167.114 321.879 166.974 321.392 166.836 320.905C168.642 320.387 170.447 319.865 172.251 319.34C172.392 319.826 172.532 320.313 172.673 320.799Z",
    fill: "#723F19"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask31_1781_645",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 166,
    y: 319,
    width: 7,
    height: 4
  }, _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M172.673 320.799C170.869 321.325 169.06 321.847 167.255 322.365C167.114 321.879 166.974 321.392 166.836 320.905C168.642 320.387 170.447 319.865 172.251 319.34C172.392 319.826 172.532 320.313 172.673 320.799Z",
    fill: "white"
  }))), _g32 || (_g32 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask31_1781_645)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M167.52 322.408C167.52 322.408 168.236 321.674 167.981 320.453",
    stroke: "#583111",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.824 322.033C168.824 322.033 169.54 321.295 169.286 320.078",
    stroke: "#583111",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.129 321.657C170.129 321.657 170.844 320.919 170.587 319.703",
    stroke: "#583111",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.437 321.278C171.437 321.278 172.152 320.54 171.894 319.324",
    stroke: "#583111",
    strokeMiterlimit: 10
  }))), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M178.089 319.215C176.285 319.744 174.481 320.269 172.673 320.795C172.532 320.309 172.391 319.822 172.251 319.336C174.055 318.81 175.859 318.285 177.663 317.756C177.804 318.242 177.948 318.728 178.089 319.215Z",
    fill: "#723F19"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask32_1781_645",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 172,
    y: 317,
    width: 7,
    height: 4
  }, _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M178.089 319.215C176.285 319.744 174.481 320.269 172.673 320.795C172.532 320.309 172.391 319.822 172.251 319.336C174.055 318.81 175.859 318.285 177.663 317.756C177.804 318.242 177.948 318.728 178.089 319.215Z",
    fill: "white"
  }))), _g33 || (_g33 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask32_1781_645)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M172.938 320.84C172.938 320.84 173.65 320.103 173.395 318.882",
    stroke: "#583111",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.242 320.462C174.242 320.462 174.957 319.724 174.695 318.504",
    stroke: "#583111",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.546 320.079C175.546 320.079 176.257 319.341 175.999 318.121",
    stroke: "#583111",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.853 319.7C176.853 319.7 177.565 318.962 177.307 317.742",
    stroke: "#583111",
    strokeMiterlimit: 10
  }))), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M183.499 317.625C181.696 318.157 179.893 318.69 178.089 319.219C177.948 318.732 177.804 318.247 177.663 317.76C179.467 317.231 181.27 316.699 183.07 316.167C183.214 316.652 183.358 317.138 183.502 317.624L183.499 317.625Z",
    fill: "#723F19"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask33_1781_645",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 177,
    y: 316,
    width: 7,
    height: 4
  }, _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M183.499 317.625C181.696 318.157 179.893 318.69 178.089 319.219C177.948 318.732 177.804 318.247 177.663 317.76C179.467 317.231 181.27 316.699 183.07 316.167C183.214 316.652 183.358 317.138 183.502 317.624L183.499 317.625Z",
    fill: "white"
  }))), _g34 || (_g34 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask33_1781_645)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M178.354 319.261C178.354 319.261 179.065 318.52 178.804 317.304",
    stroke: "#583111",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.657 318.879C179.657 318.879 180.368 318.138 180.107 316.922",
    stroke: "#583111",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.96 318.493C180.96 318.493 181.671 317.752 181.41 316.536",
    stroke: "#583111",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.264 318.111C182.264 318.111 182.975 317.37 182.709 316.151",
    stroke: "#583111",
    strokeMiterlimit: 10
  }))), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M188.906 316.016C187.104 316.556 185.302 317.092 183.499 317.625C183.355 317.139 183.21 316.653 183.066 316.167C184.869 315.635 186.668 315.099 188.47 314.559C188.614 315.045 188.759 315.531 188.906 316.013L188.906 316.016Z",
    fill: "#723F19"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask34_1781_645",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 183,
    y: 314,
    width: 6,
    height: 4
  }, _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M188.906 316.016C187.104 316.556 185.302 317.092 183.499 317.625C183.355 317.139 183.21 316.653 183.066 316.167C184.869 315.635 186.668 315.099 188.47 314.559C188.614 315.045 188.759 315.531 188.906 316.013L188.906 316.016Z",
    fill: "white"
  }))), _g35 || (_g35 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask34_1781_645)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M183.764 317.667C183.764 317.667 184.475 316.926 184.209 315.707",
    stroke: "#583111",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.067 317.282C185.067 317.282 185.778 316.541 185.512 315.322",
    stroke: "#583111",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.369 316.892C186.369 316.892 187.076 316.151 186.811 314.933",
    stroke: "#583111",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.672 316.506C187.672 316.506 188.379 315.762 188.114 314.547",
    stroke: "#583111",
    strokeMiterlimit: 10
  }))), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M194.308 314.393C192.507 314.937 190.708 315.476 188.906 316.016C188.762 315.53 188.618 315.044 188.47 314.562C190.269 314.023 192.071 313.483 193.869 312.941C194.016 313.426 194.161 313.912 194.308 314.393Z",
    fill: "#723F19"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask35_1781_645",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 188,
    y: 312,
    width: 7,
    height: 5
  }, _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M194.308 314.393C192.507 314.937 190.708 315.476 188.906 316.016C188.762 315.53 188.618 315.044 188.47 314.562C190.269 314.023 192.071 313.483 193.869 312.941C194.016 313.426 194.161 313.912 194.308 314.393Z",
    fill: "white"
  }))), _g36 || (_g36 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask35_1781_645)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M189.171 316.055C189.171 316.055 189.878 315.311 189.613 314.096",
    stroke: "#583111",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.473 315.665C190.473 315.665 191.18 314.921 190.911 313.707",
    stroke: "#583111",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.772 315.277C191.772 315.277 192.478 314.533 192.21 313.318",
    stroke: "#583111",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.074 314.887C193.074 314.887 193.777 314.143 193.512 312.924",
    stroke: "#583111",
    strokeMiterlimit: 10
  }))), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M199.704 312.758C197.907 313.304 196.106 313.851 194.308 314.394C194.16 313.909 194.016 313.423 193.869 312.941C195.666 312.398 197.464 311.855 199.261 311.305C199.409 311.791 199.556 312.272 199.704 312.758Z",
    fill: "#723F19"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask36_1781_645",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 193,
    y: 311,
    width: 7,
    height: 4
  }, _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M199.704 312.758C197.907 313.304 196.106 313.851 194.308 314.394C194.16 313.909 194.016 313.423 193.869 312.941C195.666 312.398 197.464 311.855 199.261 311.305C199.409 311.791 199.556 312.272 199.704 312.758Z",
    fill: "white"
  }))), _g37 || (_g37 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask36_1781_645)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M194.572 314.433C194.572 314.433 195.279 313.689 195.007 312.471",
    stroke: "#583111",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.874 314.04C195.874 314.04 196.581 313.296 196.308 312.078",
    stroke: "#583111",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.172 313.648C197.172 313.648 197.875 312.9 197.606 311.686",
    stroke: "#583111",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.474 313.254C198.474 313.254 199.177 312.507 198.905 311.293",
    stroke: "#583111",
    strokeMiterlimit: 10
  }))), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M205.097 311.107C203.301 311.66 201.505 312.21 199.704 312.757C199.556 312.272 199.409 311.79 199.261 311.305C201.058 310.759 202.855 310.209 204.651 309.655C204.799 310.14 204.949 310.621 205.097 311.107Z",
    fill: "#723F19"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask37_1781_645",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 199,
    y: 309,
    width: 7,
    height: 4
  }, _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M205.097 311.107C203.301 311.66 201.505 312.21 199.704 312.757C199.556 312.272 199.409 311.79 199.261 311.305C201.058 310.759 202.855 310.209 204.651 309.655C204.799 310.14 204.949 310.621 205.097 311.107Z",
    fill: "white"
  }))), _g38 || (_g38 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask37_1781_645)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M199.968 312.796C199.968 312.796 200.671 312.049 200.399 310.835",
    stroke: "#583111",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.27 312.399C201.27 312.399 201.972 311.652 201.7 310.438",
    stroke: "#583111",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.567 312.003C202.567 312.003 203.27 311.256 202.994 310.042",
    stroke: "#583111",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.868 311.606C203.868 311.606 204.571 310.859 204.295 309.642",
    stroke: "#583111",
    strokeMiterlimit: 10
  }))), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M210.485 309.443C208.69 310 206.894 310.553 205.097 311.107C204.95 310.622 204.799 310.141 204.651 309.655C206.447 309.102 208.243 308.548 210.035 307.992C210.186 308.476 210.334 308.958 210.485 309.443Z",
    fill: "#723F19"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask38_1781_645",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 204,
    y: 307,
    width: 7,
    height: 5
  }, _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M210.485 309.443C208.69 310 206.894 310.553 205.097 311.107C204.95 310.622 204.799 310.141 204.651 309.655C206.447 309.102 208.243 308.548 210.035 307.992C210.186 308.476 210.334 308.958 210.485 309.443Z",
    fill: "white"
  }))), _g39 || (_g39 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask38_1781_645)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M205.362 311.145C205.362 311.145 206.065 310.398 205.788 309.181",
    stroke: "#583111",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.662 310.745C206.662 310.745 207.361 309.995 207.085 308.781",
    stroke: "#583111",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.959 310.345C207.959 310.345 208.658 309.595 208.382 308.382",
    stroke: "#583111",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.256 309.946C209.256 309.946 209.955 309.196 209.679 307.982",
    stroke: "#583111",
    strokeMiterlimit: 10
  }))), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M215.87 307.764C214.076 308.325 212.281 308.886 210.485 309.443C210.334 308.958 210.186 308.477 210.035 307.992C211.83 307.435 213.622 306.878 215.413 306.314C215.564 306.799 215.715 307.28 215.867 307.765L215.87 307.764Z",
    fill: "#723F19"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask39_1781_645",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 210,
    y: 306,
    width: 6,
    height: 4
  }, _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M215.87 307.764C214.076 308.325 212.281 308.886 210.485 309.443C210.334 308.958 210.186 308.477 210.035 307.992C211.83 307.435 213.622 306.878 215.413 306.314C215.564 306.799 215.715 307.28 215.867 307.765L215.87 307.764Z",
    fill: "white"
  }))), _g40 || (_g40 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask39_1781_645)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M210.75 309.481C210.75 309.481 211.448 308.731 211.169 307.518",
    stroke: "#583111",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.05 309.081C212.05 309.081 212.749 308.331 212.469 307.118",
    stroke: "#583111",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.346 308.674C213.346 308.674 214.044 307.924 213.765 306.708",
    stroke: "#583111",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.642 308.271C214.642 308.271 215.341 307.521 215.057 306.305",
    stroke: "#583111",
    strokeMiterlimit: 10
  }))), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M221.25 306.075C219.46 306.642 217.665 307.203 215.871 307.767C215.719 307.283 215.568 306.802 215.417 306.317C217.208 305.757 219.003 305.192 220.793 304.625C220.944 305.11 221.099 305.59 221.25 306.075Z",
    fill: "#723F19"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask40_1781_645",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 215,
    y: 304,
    width: 7,
    height: 4
  }, _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M221.25 306.075C219.46 306.642 217.665 307.203 215.871 307.767C215.719 307.283 215.568 306.802 215.417 306.317C217.208 305.757 219.003 305.192 220.793 304.625C220.944 305.11 221.099 305.59 221.25 306.075Z",
    fill: "white"
  }))), _g41 || (_g41 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask40_1781_645)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M216.135 307.802C216.135 307.802 216.833 307.048 216.55 305.836",
    stroke: "#583111",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.431 307.399C217.431 307.399 218.129 306.645 217.846 305.433",
    stroke: "#583111",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.727 306.993C218.727 306.993 219.425 306.239 219.138 305.027",
    stroke: "#583111",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.022 306.581C220.022 306.581 220.717 305.828 220.434 304.616",
    stroke: "#583111",
    strokeMiterlimit: 10
  }))), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M226.624 304.369C224.834 304.94 223.041 305.508 221.25 306.076C221.099 305.591 220.944 305.11 220.793 304.626C222.583 304.058 224.373 303.491 226.163 302.923C226.318 303.404 226.469 303.889 226.624 304.369Z",
    fill: "#723F19"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask41_1781_645",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 220,
    y: 302,
    width: 7,
    height: 5
  }, _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M226.624 304.369C224.834 304.94 223.041 305.508 221.25 306.076C221.099 305.591 220.944 305.11 220.793 304.626C222.583 304.058 224.373 303.491 226.163 302.923C226.318 303.404 226.469 303.889 226.624 304.369Z",
    fill: "white"
  }))), _g42 || (_g42 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask41_1781_645)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M221.515 306.114C221.515 306.114 222.209 305.361 221.926 304.148",
    stroke: "#583111",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.81 305.704C222.81 305.704 223.504 304.95 223.218 303.739",
    stroke: "#583111",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.105 305.293C224.105 305.293 224.8 304.54 224.513 303.324",
    stroke: "#583111",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.4 304.882C225.4 304.882 226.094 304.125 225.808 302.913",
    stroke: "#583111",
    strokeMiterlimit: 10
  }))), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M231.995 302.652C230.206 303.227 228.418 303.801 226.624 304.373C226.47 303.892 226.318 303.408 226.164 302.927C227.953 302.356 229.743 301.785 231.532 301.211C231.686 301.691 231.842 302.175 231.996 302.656L231.995 302.652Z",
    fill: "#723F19"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask42_1781_645",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 226,
    y: 301,
    width: 6,
    height: 4
  }, _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M231.995 302.652C230.206 303.227 228.418 303.801 226.624 304.373C226.47 303.892 226.318 303.408 226.164 302.927C227.953 302.356 229.743 301.785 231.532 301.211C231.686 301.691 231.842 302.175 231.996 302.656L231.995 302.652Z",
    fill: "white"
  }))), _g43 || (_g43 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask42_1781_645)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M226.888 304.408C226.888 304.408 227.582 303.652 227.292 302.44",
    stroke: "#583111",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.183 303.993C228.183 303.993 228.877 303.237 228.586 302.025",
    stroke: "#583111",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.477 303.579C229.477 303.579 230.171 302.822 229.881 301.611",
    stroke: "#583111",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.772 303.165C230.772 303.165 231.466 302.408 231.172 301.198",
    stroke: "#583111",
    strokeMiterlimit: 10
  }))), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M237.361 300.917C235.572 301.495 233.784 302.073 231.995 302.651C231.841 302.171 231.686 301.687 231.531 301.206C233.32 300.632 235.105 300.054 236.894 299.476C237.048 299.956 237.207 300.44 237.361 300.92L237.361 300.917Z",
    fill: "#723F19"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask43_1781_645",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 231,
    y: 299,
    width: 7,
    height: 4
  }, _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M237.361 300.917C235.572 301.495 233.784 302.073 231.995 302.651C231.841 302.171 231.686 301.687 231.531 301.206C233.32 300.632 235.105 300.054 236.894 299.476C237.048 299.956 237.207 300.44 237.361 300.92L237.361 300.917Z",
    fill: "white"
  }))), _g44 || (_g44 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask43_1781_645)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M232.259 302.688C232.259 302.688 232.95 301.931 232.659 300.72",
    stroke: "#583111",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.553 302.27C233.553 302.27 234.244 301.513 233.954 300.302",
    stroke: "#583111",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.844 301.856C234.844 301.856 235.534 301.096 235.24 299.886",
    stroke: "#583111",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.138 301.434C236.138 301.434 236.828 300.675 236.534 299.464",
    stroke: "#583111",
    strokeMiterlimit: 10
  }))), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M242.721 299.172C240.934 299.758 239.149 300.339 237.361 300.917C237.206 300.437 237.048 299.953 236.893 299.472C238.682 298.894 240.465 298.309 242.25 297.728C242.408 298.208 242.566 298.692 242.721 299.172Z",
    fill: "#723F19"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask44_1781_645",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 236,
    y: 297,
    width: 7,
    height: 4
  }, _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M242.721 299.172C240.934 299.758 239.149 300.339 237.361 300.917C237.206 300.437 237.048 299.953 236.893 299.472C238.682 298.894 240.465 298.309 242.25 297.728C242.408 298.208 242.566 298.692 242.721 299.172Z",
    fill: "white"
  }))), _g45 || (_g45 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask44_1781_645)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M237.625 300.952C237.625 300.952 238.314 300.192 238.021 298.981",
    stroke: "#583111",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.919 300.534C238.919 300.534 239.608 299.774 239.311 298.564",
    stroke: "#583111",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.208 300.113C240.208 300.113 240.895 299.354 240.601 298.143",
    stroke: "#583111",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.498 299.693C241.498 299.693 242.188 298.933 241.891 297.723",
    stroke: "#583111",
    strokeMiterlimit: 10
  }))), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M248.074 297.41C246.291 297.998 244.504 298.587 242.717 299.169C242.558 298.689 242.4 298.206 242.245 297.725C244.029 297.14 245.813 296.556 247.599 295.967C247.757 296.447 247.915 296.926 248.074 297.41Z",
    fill: "#723F19"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask45_1781_645",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 242,
    y: 295,
    width: 7,
    height: 5
  }, _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M248.074 297.41C246.291 297.998 244.504 298.587 242.717 299.169C242.558 298.689 242.4 298.206 242.245 297.725C244.029 297.14 245.813 296.556 247.599 295.967C247.757 296.447 247.915 296.926 248.074 297.41Z",
    fill: "white"
  }))), _g46 || (_g46 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask45_1781_645)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M242.985 299.208C242.985 299.208 243.674 298.448 243.373 297.238",
    stroke: "#583111",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.277 298.782C244.277 298.782 244.963 298.019 244.666 296.813",
    stroke: "#583111",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.567 298.358C245.567 298.358 246.252 297.595 245.955 296.385",
    stroke: "#583111",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.856 297.934C246.856 297.934 247.542 297.171 247.241 295.962",
    stroke: "#583111",
    strokeMiterlimit: 10
  }))), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M253.426 295.638C251.643 296.23 249.857 296.822 248.074 297.411C247.916 296.931 247.758 296.451 247.599 295.967C249.382 295.379 251.165 294.787 252.947 294.195C253.106 294.675 253.267 295.154 253.426 295.638Z",
    fill: "#723F19"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask46_1781_645",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 247,
    y: 294,
    width: 7,
    height: 4
  }, _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M253.426 295.638C251.643 296.23 249.857 296.822 248.074 297.411C247.916 296.931 247.758 296.451 247.599 295.967C249.382 295.379 251.165 294.787 252.947 294.195C253.106 294.675 253.267 295.154 253.426 295.638Z",
    fill: "white"
  }))), _g47 || (_g47 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask46_1781_645)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M248.342 297.445C248.342 297.445 249.027 296.682 248.726 295.472",
    stroke: "#583111",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.631 297.021C249.631 297.021 250.316 296.258 250.016 295.049",
    stroke: "#583111",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.92 296.592C250.92 296.592 251.605 295.829 251.301 294.62",
    stroke: "#583111",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.208 296.165C252.208 296.165 252.894 295.402 252.589 294.193",
    stroke: "#583111",
    strokeMiterlimit: 10
  }))), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M258.775 293.847C256.993 294.446 255.211 295.041 253.429 295.633C253.271 295.153 253.109 294.674 252.95 294.19C254.733 293.598 256.515 293.003 258.293 292.404C258.454 292.884 258.616 293.363 258.778 293.842L258.775 293.847Z",
    fill: "#723F19"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask47_1781_645",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 252,
    y: 292,
    width: 7,
    height: 4
  }, _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M258.775 293.847C256.993 294.446 255.211 295.041 253.429 295.633C253.271 295.153 253.109 294.674 252.95 294.19C254.733 293.598 256.515 293.003 258.293 292.404C258.454 292.884 258.616 293.363 258.778 293.842L258.775 293.847Z",
    fill: "white"
  }))), _g48 || (_g48 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask47_1781_645)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M253.693 295.672C253.693 295.672 254.374 294.907 254.074 293.701",
    stroke: "#583111",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.981 295.241C254.981 295.241 255.666 294.474 255.359 293.27",
    stroke: "#583111",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.269 294.809C256.269 294.809 256.951 294.043 256.646 292.834",
    stroke: "#583111",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.558 294.377C257.558 294.377 258.239 293.611 257.935 292.402",
    stroke: "#583111",
    strokeMiterlimit: 10
  }))), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M264.115 292.046C262.334 292.649 260.553 293.248 258.771 293.847C258.609 293.368 258.448 292.888 258.286 292.409C260.067 291.81 261.845 291.211 263.622 290.609C263.784 291.088 263.946 291.568 264.111 292.047L264.115 292.046Z",
    fill: "#723F19"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask48_1781_645",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 258,
    y: 290,
    width: 7,
    height: 4
  }, _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M264.115 292.046C262.334 292.649 260.553 293.248 258.771 293.847C258.609 293.368 258.448 292.888 258.286 292.409C260.067 291.81 261.845 291.211 263.622 290.609C263.784 291.088 263.946 291.568 264.111 292.047L264.115 292.046Z",
    fill: "white"
  }))), _g49 || (_g49 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask48_1781_645)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M259.039 293.882C259.039 293.882 259.72 293.116 259.412 291.908",
    stroke: "#583111",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.327 293.45C260.327 293.45 261.008 292.685 260.7 291.476",
    stroke: "#583111",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.614 293.016C261.614 293.016 262.296 292.25 261.988 291.041",
    stroke: "#583111",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.902 292.58C262.902 292.58 263.583 291.811 263.272 290.607",
    stroke: "#583111",
    strokeMiterlimit: 10
  }))), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M269.452 290.231C267.676 290.837 265.895 291.444 264.115 292.046C263.953 291.567 263.791 291.088 263.626 290.609C265.403 290.007 267.183 289.4 268.96 288.794C269.125 289.273 269.287 289.753 269.452 290.231Z",
    fill: "#723F19"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask49_1781_645",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 263,
    y: 288,
    width: 7,
    height: 5
  }, _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M269.452 290.231C267.676 290.837 265.895 291.444 264.115 292.046C263.953 291.567 263.791 291.088 263.626 290.609C265.403 290.007 267.183 289.4 268.96 288.794C269.125 289.273 269.287 289.753 269.452 290.231Z",
    fill: "white"
  }))), _g50 || (_g50 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask49_1781_645)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M264.382 292.081C264.382 292.081 265.063 291.312 264.752 290.108",
    stroke: "#583111",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.669 291.643C265.669 291.643 266.35 290.873 266.039 289.669",
    stroke: "#583111",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.953 291.208C266.953 291.208 267.63 290.439 267.319 289.235",
    stroke: "#583111",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.24 290.769C268.24 290.769 268.917 290 268.606 288.793",
    stroke: "#583111",
    strokeMiterlimit: 10
  }))), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M274.784 288.402C273.009 289.015 271.229 289.625 269.452 290.231C269.287 289.752 269.125 289.273 268.96 288.794C270.737 288.188 272.513 287.579 274.288 286.966C274.453 287.445 274.619 287.924 274.784 288.402Z",
    fill: "#723F19"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask50_1781_645",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 268,
    y: 286,
    width: 7,
    height: 5
  }, _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M274.784 288.402C273.009 289.015 271.229 289.625 269.452 290.231C269.287 289.752 269.125 289.273 268.96 288.794C270.737 288.188 272.513 287.579 274.288 286.966C274.453 287.445 274.619 287.924 274.784 288.402Z",
    fill: "white"
  }))), _g51 || (_g51 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask50_1781_645)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M269.719 290.263C269.719 290.263 270.396 289.494 270.081 288.286",
    stroke: "#583111",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.002 289.824C271.002 289.824 271.68 289.055 271.364 287.848",
    stroke: "#583111",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.289 289.382C272.289 289.382 272.966 288.613 272.651 287.406",
    stroke: "#583111",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.572 288.943C273.572 288.943 274.249 288.171 273.934 286.967",
    stroke: "#583111",
    strokeMiterlimit: 10
  }))), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M280.11 286.56C278.335 287.176 276.559 287.789 274.784 288.402C274.619 287.923 274.453 287.445 274.288 286.966C276.064 286.353 277.839 285.74 279.61 285.124C279.776 285.603 279.944 286.081 280.11 286.56Z",
    fill: "#723F19"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask51_1781_645",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 274,
    y: 285,
    width: 7,
    height: 4
  }, _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M280.11 286.56C278.335 287.176 276.559 287.789 274.784 288.402C274.619 287.923 274.453 287.445 274.288 286.966C276.064 286.353 277.839 285.74 279.61 285.124C279.776 285.603 279.944 286.081 280.11 286.56Z",
    fill: "white"
  }))), _g52 || (_g52 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask51_1781_645)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M275.051 288.433C275.051 288.433 275.727 287.661 275.409 286.458",
    stroke: "#583111",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.334 287.991C276.334 287.991 277.01 287.219 276.692 286.015",
    stroke: "#583111",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.616 287.547C277.616 287.547 278.292 286.774 277.974 285.571",
    stroke: "#583111",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.902 287.1C278.902 287.1 279.575 286.328 279.256 285.122",
    stroke: "#583111",
    strokeMiterlimit: 10
  }))), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M285.433 284.703C283.659 285.323 281.885 285.943 280.11 286.56C279.945 286.081 279.776 285.602 279.61 285.124C281.385 284.507 283.156 283.887 284.93 283.267C285.099 283.746 285.264 284.224 285.433 284.699L285.433 284.703Z",
    fill: "#723F19"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask52_1781_645",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 279,
    y: 283,
    width: 7,
    height: 4
  }, _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M285.433 284.703C283.659 285.323 281.885 285.943 280.11 286.56C279.945 286.081 279.776 285.602 279.61 285.124C281.385 284.507 283.156 283.887 284.93 283.267C285.099 283.746 285.264 284.224 285.433 284.699L285.433 284.703Z",
    fill: "white"
  }))), _g53 || (_g53 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask52_1781_645)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M280.377 286.59C280.377 286.59 281.05 285.818 280.731 284.612",
    stroke: "#583111",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.662 286.141C281.662 286.141 282.334 285.366 282.016 284.163",
    stroke: "#583111",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.944 285.696C282.944 285.696 283.617 284.92 283.295 283.718",
    stroke: "#583111",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.226 285.247C284.226 285.247 284.898 284.471 284.576 283.269",
    stroke: "#583111",
    strokeMiterlimit: 10
  }))), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M290.751 282.832C288.978 283.459 287.208 284.082 285.433 284.703C285.264 284.224 285.099 283.745 284.931 283.271C286.701 282.651 288.475 282.027 290.245 281.401C290.414 281.879 290.582 282.354 290.751 282.832Z",
    fill: "#723F19"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask53_1781_645",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 284,
    y: 281,
    width: 7,
    height: 4
  }, _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M290.751 282.832C288.978 283.459 287.208 284.082 285.433 284.703C285.264 284.224 285.099 283.745 284.931 283.271C286.701 282.651 288.475 282.027 290.245 281.401C290.414 281.879 290.582 282.354 290.751 282.832Z",
    fill: "white"
  }))), _g54 || (_g54 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask53_1781_645)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M285.7 284.733C285.7 284.733 286.372 283.957 286.047 282.756",
    stroke: "#583111",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.981 284.281C286.981 284.281 287.654 283.505 287.328 282.303",
    stroke: "#583111",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.263 283.832C288.263 283.832 288.935 283.056 288.61 281.854",
    stroke: "#583111",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.544 283.379C289.544 283.379 290.213 282.604 289.887 281.403",
    stroke: "#583111",
    strokeMiterlimit: 10
  }))), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M296.063 280.948C294.294 281.578 292.52 282.206 290.751 282.833C290.582 282.354 290.414 281.88 290.245 281.401C292.014 280.775 293.784 280.148 295.553 279.517C295.722 279.996 295.894 280.47 296.063 280.948Z",
    fill: "#723F19"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask54_1781_645",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 290,
    y: 279,
    width: 7,
    height: 4
  }, _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M296.063 280.948C294.294 281.578 292.52 282.206 290.751 282.833C290.582 282.354 290.414 281.88 290.245 281.401C292.014 280.775 293.784 280.148 295.553 279.517C295.722 279.996 295.894 280.47 296.063 280.948Z",
    fill: "white"
  }))), _g55 || (_g55 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask54_1781_645)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M291.017 282.86C291.017 282.86 291.685 282.081 291.36 280.879",
    stroke: "#583111",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.298 282.406C292.298 282.406 292.966 281.628 292.641 280.426",
    stroke: "#583111",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.579 281.954C293.579 281.954 294.247 281.176 293.918 279.974",
    stroke: "#583111",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.856 281.499C294.856 281.499 295.524 280.721 295.195 279.519",
    stroke: "#583111",
    strokeMiterlimit: 10
  }))), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M301.372 279.049C299.604 279.683 297.835 280.317 296.066 280.947C295.897 280.469 295.725 279.995 295.556 279.516C297.325 278.886 299.094 278.256 300.859 277.619C301.031 278.096 301.2 278.571 301.372 279.049Z",
    fill: "#723F19"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask55_1781_645",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 295,
    y: 277,
    width: 7,
    height: 4
  }, _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M301.372 279.049C299.604 279.683 297.835 280.317 296.066 280.947C295.897 280.469 295.725 279.995 295.556 279.516C297.325 278.886 299.094 278.256 300.859 277.619C301.031 278.096 301.2 278.571 301.372 279.049Z",
    fill: "white"
  }))), _g56 || (_g56 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask55_1781_645)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M296.329 280.975C296.329 280.975 296.997 280.196 296.668 278.995",
    stroke: "#583111",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.609 280.519C297.609 280.519 298.278 279.74 297.945 278.539",
    stroke: "#583111",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.886 280.063C298.886 280.063 299.554 279.284 299.222 278.083",
    stroke: "#583111",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.167 279.608C300.167 279.608 300.831 278.83 300.502 277.628",
    stroke: "#583111",
    strokeMiterlimit: 10
  }))), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M306.672 277.14C304.905 277.781 303.137 278.415 301.369 279.053C301.197 278.575 301.028 278.101 300.856 277.623C302.624 276.989 304.388 276.352 306.156 275.714C306.329 276.192 306.501 276.666 306.673 277.144L306.672 277.14Z",
    fill: "#723F19"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask56_1781_645",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 300,
    y: 275,
    width: 7,
    height: 5
  }, _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M306.672 277.14C304.905 277.781 303.137 278.415 301.369 279.053C301.197 278.575 301.028 278.101 300.856 277.623C302.624 276.989 304.388 276.352 306.156 275.714C306.329 276.192 306.501 276.666 306.673 277.144L306.672 277.14Z",
    fill: "white"
  }))), _g57 || (_g57 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask56_1781_645)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M301.638 279.076C301.638 279.076 302.302 278.295 301.97 277.094",
    stroke: "#583111",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.915 278.617C302.915 278.617 303.579 277.836 303.246 276.635",
    stroke: "#583111",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.191 278.158C304.191 278.158 304.855 277.377 304.522 276.176",
    stroke: "#583111",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.471 277.698C305.471 277.698 306.135 276.917 305.799 275.716",
    stroke: "#583111",
    strokeMiterlimit: 10
  }))), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M311.97 275.213C310.207 275.858 308.44 276.499 306.673 277.14C306.5 276.662 306.328 276.188 306.156 275.711C307.92 275.074 309.687 274.429 311.45 273.788C311.622 274.262 311.798 274.739 311.97 275.213Z",
    fill: "#723F19"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask57_1781_645",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 306,
    y: 273,
    width: 6,
    height: 5
  }, _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M311.97 275.213C310.207 275.858 308.44 276.499 306.673 277.14C306.5 276.662 306.328 276.188 306.156 275.711C307.92 275.074 309.687 274.429 311.45 273.788C311.622 274.262 311.798 274.739 311.97 275.213Z",
    fill: "white"
  }))), _g58 || (_g58 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask57_1781_645)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M306.943 277.167C306.943 277.167 307.607 276.385 307.27 275.185",
    stroke: "#583111",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.218 276.704C308.218 276.704 308.882 275.922 308.546 274.722",
    stroke: "#583111",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.493 276.238C309.493 276.238 310.157 275.457 309.818 274.257",
    stroke: "#583111",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.769 275.775C310.769 275.775 311.432 274.99 311.093 273.794",
    stroke: "#583111",
    strokeMiterlimit: 10
  }))), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M317.262 273.273C315.499 273.921 313.733 274.569 311.97 275.214C311.798 274.736 311.622 274.262 311.45 273.788C313.213 273.144 314.976 272.5 316.739 271.852C316.914 272.326 317.087 272.803 317.262 273.277L317.262 273.273Z",
    fill: "#723F19"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask58_1781_645",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 311,
    y: 271,
    width: 7,
    height: 5
  }, _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M317.262 273.273C315.499 273.921 313.733 274.569 311.97 275.214C311.798 274.736 311.622 274.262 311.45 273.788C313.213 273.144 314.976 272.5 316.739 271.852C316.914 272.326 317.087 272.803 317.262 273.277L317.262 273.273Z",
    fill: "white"
  }))), _g59 || (_g59 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask58_1781_645)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M312.236 275.241C312.236 275.241 312.896 274.457 312.561 273.26",
    stroke: "#583111",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.511 274.774C313.511 274.774 314.171 273.989 313.832 272.79",
    stroke: "#583111",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.787 274.308C314.787 274.308 315.447 273.524 315.107 272.324",
    stroke: "#583111",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.061 273.838C316.061 273.838 316.721 273.054 316.381 271.854",
    stroke: "#583111",
    strokeMiterlimit: 10
  }))), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M322.552 271.322C320.79 271.973 319.028 272.625 317.265 273.272C317.09 272.799 316.917 272.321 316.742 271.848C318.504 271.2 320.266 270.549 322.025 269.898C322.2 270.371 322.376 270.848 322.552 271.322Z",
    fill: "#723F19"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask59_1781_645",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 316,
    y: 269,
    width: 7,
    height: 5
  }, _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M322.552 271.322C320.79 271.973 319.028 272.625 317.265 273.272C317.09 272.799 316.917 272.321 316.742 271.848C318.504 271.2 320.266 270.549 322.025 269.898C322.2 270.371 322.376 270.848 322.552 271.322Z",
    fill: "white"
  }))), _g60 || (_g60 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask59_1781_645)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M317.532 273.299C317.532 273.299 318.192 272.515 317.848 271.316",
    stroke: "#583111",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.802 272.831C318.802 272.831 319.462 272.046 319.119 270.847",
    stroke: "#583111",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.077 272.361C320.077 272.361 320.736 271.573 320.394 270.377",
    stroke: "#583111",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.352 271.89C321.352 271.89 322.011 271.102 321.665 269.907",
    stroke: "#583111",
    strokeMiterlimit: 10
  }))), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M327.832 269.357C326.072 270.016 324.31 270.671 322.548 271.322C322.373 270.849 322.197 270.372 322.021 269.898C323.783 269.247 325.541 268.592 327.302 267.934C327.477 268.407 327.657 268.884 327.832 269.357Z",
    fill: "#723F19"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask60_1781_645",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 322,
    y: 267,
    width: 6,
    height: 5
  }, _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M327.832 269.357C326.072 270.016 324.31 270.671 322.548 271.322C322.373 270.849 322.197 270.372 322.021 269.898C323.783 269.247 325.541 268.592 327.302 267.934C327.477 268.407 327.657 268.884 327.832 269.357Z",
    fill: "white"
  }))), _g61 || (_g61 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask60_1781_645)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M322.817 271.345C322.817 271.345 323.477 270.557 323.13 269.362",
    stroke: "#583111",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.092 270.876C324.092 270.876 324.748 270.088 324.405 268.893",
    stroke: "#583111",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.362 270.403C325.362 270.403 326.018 269.615 325.672 268.42",
    stroke: "#583111",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.636 269.925C326.636 269.925 327.291 269.137 326.944 267.939",
    stroke: "#583111",
    strokeMiterlimit: 10
  }))), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M333.11 267.375C331.353 268.036 329.593 268.699 327.832 269.354C327.656 268.88 327.477 268.404 327.301 267.93C329.058 267.272 330.819 266.614 332.576 265.952C332.755 266.425 332.934 266.898 333.11 267.375Z",
    fill: "#723F19"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask61_1781_645",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 327,
    y: 265,
    width: 7,
    height: 5
  }, _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M333.11 267.375C331.353 268.036 329.593 268.699 327.832 269.354C327.656 268.88 327.477 268.404 327.301 267.93C329.058 267.272 330.819 266.614 332.576 265.952C332.755 266.425 332.934 266.898 333.11 267.375Z",
    fill: "white"
  }))), _g62 || (_g62 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask61_1781_645)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M328.102 269.381C328.102 269.381 328.757 268.594 328.41 267.395",
    stroke: "#583111",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.371 268.905C329.371 268.905 330.027 268.117 329.676 266.919",
    stroke: "#583111",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.641 268.428C330.641 268.428 331.296 267.637 330.946 266.443",
    stroke: "#583111",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.914 267.95C331.914 267.95 332.57 267.159 332.22 265.965",
    stroke: "#583111",
    strokeMiterlimit: 10
  }))), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M338.382 265.383C336.626 266.048 334.87 266.713 333.11 267.375C332.931 266.902 332.752 266.429 332.576 265.952C334.332 265.291 336.088 264.626 337.844 263.96C338.023 264.433 338.202 264.906 338.382 265.379L338.382 265.383Z",
    fill: "#723F19"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask62_1781_645",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 332,
    y: 263,
    width: 7,
    height: 5
  }, _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M338.382 265.383C336.626 266.048 334.87 266.713 333.11 267.375C332.931 266.902 332.752 266.429 332.576 265.952C334.332 265.291 336.088 264.626 337.844 263.96C338.023 264.433 338.202 264.906 338.382 265.379L338.382 265.383Z",
    fill: "white"
  }))), _g63 || (_g63 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask62_1781_645)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M333.375 267.399C333.375 267.399 334.027 266.608 333.677 265.414",
    stroke: "#583111",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.649 266.921C334.649 266.921 335.3 266.131 334.95 264.936",
    stroke: "#583111",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.918 266.441C335.918 266.441 336.57 265.65 336.22 264.456",
    stroke: "#583111",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.187 265.961C337.187 265.961 337.839 265.171 337.485 263.977",
    stroke: "#583111",
    strokeMiterlimit: 10
  }))), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M343.648 263.376C341.894 264.049 340.138 264.717 338.382 265.383C338.203 264.91 338.024 264.437 337.845 263.964C339.601 263.299 341.353 262.63 343.107 261.958C343.29 262.43 343.469 262.903 343.648 263.376Z",
    fill: "#723F19"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask63_1781_645",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 337,
    y: 261,
    width: 7,
    height: 5
  }, _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M343.648 263.376C341.894 264.049 340.138 264.717 338.382 265.383C338.203 264.91 338.024 264.437 337.845 263.964C339.601 263.299 341.353 262.63 343.107 261.958C343.29 262.43 343.469 262.903 343.648 263.376Z",
    fill: "white"
  }))), _g64 || (_g64 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask63_1781_645)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M338.648 265.405C338.648 265.405 339.299 264.615 338.945 263.417",
    stroke: "#583111",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.917 264.922C339.917 264.922 340.568 264.128 340.214 262.934",
    stroke: "#583111",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.185 264.438C341.185 264.438 341.836 263.644 341.479 262.451",
    stroke: "#583111",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.454 263.955C342.454 263.955 343.105 263.161 342.747 261.968",
    stroke: "#583111",
    strokeMiterlimit: 10
  }))), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M348.909 261.357C347.155 262.033 345.403 262.704 343.649 263.377C343.466 262.904 343.287 262.432 343.108 261.959C344.863 261.286 346.614 260.614 348.365 259.939L348.913 261.356L348.909 261.357Z",
    fill: "#723F19"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask64_1781_645",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 343,
    y: 259,
    width: 6,
    height: 5
  }, _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M348.909 261.357C347.155 262.033 345.403 262.704 343.649 263.377C343.466 262.904 343.287 262.432 343.108 261.959C344.863 261.286 346.614 260.614 348.365 259.939L348.913 261.356L348.909 261.357Z",
    fill: "white"
  }))), _g65 || (_g65 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask64_1781_645)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M343.918 263.4C343.918 263.4 344.565 262.607 344.212 261.413",
    stroke: "#583111",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.182 262.913C345.182 262.913 345.83 262.119 345.473 260.926",
    stroke: "#583111",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.45 262.426C346.45 262.426 347.098 261.632 346.741 260.439",
    stroke: "#583111",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.719 261.938C347.719 261.938 348.366 261.145 348.009 259.952",
    stroke: "#583111",
    strokeMiterlimit: 10
  }))), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M354.167 259.321C352.417 260 350.663 260.68 348.909 261.356L348.361 259.939C350.112 259.263 351.862 258.584 353.612 257.905C353.794 258.378 353.977 258.85 354.163 259.322L354.167 259.321Z",
    fill: "#723F19"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask65_1781_645",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 348,
    y: 257,
    width: 7,
    height: 5
  }, _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M354.167 259.321C352.417 260 350.663 260.68 348.909 261.356L348.361 259.939C350.112 259.263 351.862 258.584 353.612 257.905C353.794 258.378 353.977 258.85 354.163 259.322L354.167 259.321Z",
    fill: "white"
  }))), _g66 || (_g66 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask65_1781_645)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M349.178 261.376C349.178 261.376 349.824 260.579 349.464 259.39",
    stroke: "#583111",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.446 260.888C350.446 260.888 351.092 260.091 350.732 258.899",
    stroke: "#583111",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.71 260.398C351.71 260.398 352.356 259.601 351.996 258.408",
    stroke: "#583111",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.977 259.907C352.977 259.907 353.624 259.11 353.259 257.918",
    stroke: "#583111",
    strokeMiterlimit: 10
  }))), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M359.416 257.273C357.667 257.96 355.917 258.642 354.164 259.322C353.981 258.849 353.798 258.377 353.612 257.905C355.362 257.226 357.111 256.544 358.86 255.858C359.047 256.329 359.229 256.802 359.416 257.273Z",
    fill: "#723F19"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask66_1781_645",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 353,
    y: 255,
    width: 7,
    height: 5
  }, _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M359.416 257.273C357.667 257.96 355.917 258.642 354.164 259.322C353.981 258.849 353.798 258.377 353.612 257.905C355.362 257.226 357.111 256.544 358.86 255.858C359.047 256.329 359.229 256.802 359.416 257.273Z",
    fill: "white"
  }))), _g67 || (_g67 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask66_1781_645)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M354.432 259.341C354.432 259.341 355.079 258.544 354.715 257.352",
    stroke: "#583111",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.7 258.851C355.7 258.851 356.347 258.054 355.979 256.863",
    stroke: "#583111",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.963 258.357C356.963 258.357 357.606 257.56 357.242 256.368",
    stroke: "#583111",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.23 257.862C358.23 257.862 358.873 257.065 358.509 255.873",
    stroke: "#583111",
    strokeMiterlimit: 10
  }))), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M364.662 255.212C362.914 255.902 361.165 256.588 359.416 257.274C359.229 256.802 359.047 256.33 358.86 255.858C360.609 255.172 362.355 254.486 364.103 253.797C364.289 254.268 364.476 254.74 364.662 255.208L364.662 255.212Z",
    fill: "#723F19"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask67_1781_645",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 358,
    y: 253,
    width: 7,
    height: 5
  }, _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M364.662 255.212C362.914 255.902 361.165 256.588 359.416 257.274C359.229 256.802 359.047 256.33 358.86 255.858C360.609 255.172 362.355 254.486 364.103 253.797C364.289 254.268 364.476 254.74 364.662 255.208L364.662 255.212Z",
    fill: "white"
  }))), _g68 || (_g68 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask67_1781_645)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M359.684 257.294C359.684 257.294 360.327 256.493 359.959 255.306",
    stroke: "#583111",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.948 256.799C360.948 256.799 361.591 255.999 361.223 254.811",
    stroke: "#583111",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.214 256.301C362.214 256.301 362.857 255.501 362.489 254.309",
    stroke: "#583111",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.477 255.804C363.477 255.804 364.12 255.004 363.748 253.813",
    stroke: "#583111",
    strokeMiterlimit: 10
  }))), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M369.903 253.139C368.159 253.832 366.411 254.526 364.663 255.215C364.476 254.744 364.29 254.272 364.104 253.804C365.849 253.114 367.598 252.425 369.342 251.732C369.528 252.204 369.714 252.672 369.904 253.143L369.903 253.139Z",
    fill: "#723F19"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask68_1781_645",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 364,
    y: 251,
    width: 6,
    height: 5
  }, _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M369.903 253.139C368.159 253.832 366.411 254.526 364.663 255.215C364.476 254.744 364.29 254.272 364.104 253.804C365.849 253.114 367.598 252.425 369.342 251.732C369.528 252.204 369.714 252.672 369.904 253.143L369.903 253.139Z",
    fill: "white"
  }))), _g69 || (_g69 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask68_1781_645)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M364.931 255.231C364.931 255.231 365.573 254.431 365.202 253.24",
    stroke: "#583111",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.194 254.734C366.194 254.734 366.832 253.934 366.464 252.743",
    stroke: "#583111",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.456 254.233C367.456 254.233 368.095 253.433 367.723 252.242",
    stroke: "#583111",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.718 253.731C368.718 253.731 369.356 252.928 368.985 251.74",
    stroke: "#583111",
    strokeMiterlimit: 10
  }))), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M375.137 251.049C373.394 251.749 371.647 252.443 369.903 253.139C369.717 252.667 369.531 252.199 369.341 251.728C371.085 251.035 372.829 250.339 374.573 249.643C374.762 250.114 374.948 250.582 375.138 251.053L375.137 251.049Z",
    fill: "#723F19"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask69_1781_645",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 369,
    y: 249,
    width: 7,
    height: 5
  }, _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M375.137 251.049C373.394 251.749 371.647 252.443 369.903 253.139C369.717 252.667 369.531 252.199 369.341 251.728C371.085 251.035 372.829 250.339 374.573 249.643C374.762 250.114 374.948 250.582 375.138 251.053L375.137 251.049Z",
    fill: "white"
  }))), _g70 || (_g70 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask69_1781_645)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M370.171 253.155C370.171 253.155 370.81 252.351 370.439 251.164",
    stroke: "#583111",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.434 252.654C371.434 252.654 372.072 251.85 371.697 250.664",
    stroke: "#583111",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.695 252.15C372.695 252.15 373.333 251.346 372.959 250.16",
    stroke: "#583111",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373.954 251.649C373.954 251.649 374.592 250.846 374.217 249.659",
    stroke: "#583111",
    strokeMiterlimit: 10
  }))), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M380.366 248.946C378.624 249.65 376.881 250.35 375.138 251.05C374.948 250.578 374.762 250.11 374.572 249.639C376.316 248.943 378.058 248.239 379.798 247.54C379.988 248.011 380.177 248.478 380.367 248.95L380.366 248.946Z",
    fill: "#723F19"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask70_1781_645",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 374,
    y: 247,
    width: 7,
    height: 5
  }, _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M380.366 248.946C378.624 249.65 376.881 250.35 375.138 251.05C374.948 250.578 374.762 250.11 374.572 249.639C376.316 248.943 378.058 248.239 379.798 247.54C379.988 248.011 380.177 248.478 380.367 248.95L380.366 248.946Z",
    fill: "white"
  }))), _g71 || (_g71 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask70_1781_645)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M375.406 251.065C375.406 251.065 376.044 250.262 375.665 249.073",
    stroke: "#583111",
    strokeMiterlimit: 10
  }))), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M15.7432 358.231C14.4052 369.209 13.0162 380.191 11.5752 391.17C9.86661 404.184 8.08493 417.203 6.22659 430.226C-0.50573 418.927 -7.16843 407.602 -13.7651 396.252C-19.3285 386.676 -24.8474 377.078 -30.3136 367.465C-14.9204 364.55 0.431866 361.472 15.7432 358.231Z",
    fill: "#F3F4F5"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M15.7433 358.231C14.5004 368.445 13.2101 378.662 11.8756 388.879C2.95785 390.726 -5.9763 392.517 -14.9233 394.25C-20.0962 385.338 -25.224 376.408 -30.3141 367.461C-14.9209 364.546 0.431378 361.468 15.7427 358.227L15.7433 358.231Z",
    fill: "#265CA9"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M4.76769 364.543C5.305 365.478 5.84288 366.418 6.38379 367.352C7.4551 367.133 8.52585 366.909 9.60018 366.686C8.86179 367.486 8.1234 368.287 7.38502 369.088C7.92233 370.023 8.46381 370.962 9.00472 371.897C8.00812 371.456 7.01153 371.014 6.01494 370.573C5.27295 371.374 4.53398 372.171 3.792 372.973C3.91893 371.901 4.04529 370.826 4.16863 369.755C3.17203 369.313 2.17846 368.868 1.18488 368.422C2.2562 368.202 3.3311 367.982 4.40241 367.762C4.52877 366.687 4.65213 365.616 4.77489 364.542L4.76769 364.543Z",
    fill: "#F3F4F5"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M1.28137 376.201C1.81926 377.14 2.35658 378.075 2.89447 379.014C3.97297 378.794 5.05147 378.573 6.12638 378.352C5.3808 379.154 4.63824 379.952 3.89208 380.75C4.42997 381.689 4.97088 382.624 5.50877 383.564C4.508 383.119 3.50781 382.678 2.50704 382.234C1.76088 383.032 1.01112 383.831 0.261369 384.63C0.391902 383.558 0.521865 382.482 0.652397 381.41C-0.344777 380.965 -1.34555 380.521 -2.3433 380.072C-1.26422 379.855 -0.185138 379.637 0.893945 379.42C1.02448 378.348 1.15084 377.273 1.28137 376.201Z",
    fill: "#F3F4F5"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask71_1781_645",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -31,
    y: 358,
    width: 47,
    height: 73
  }, _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M15.7433 358.231C14.4053 369.209 13.0163 380.191 11.5753 391.17C9.86667 404.184 8.08499 417.203 6.22665 430.226C-0.505669 418.927 -7.16837 407.602 -13.7651 396.252C-19.3284 386.676 -24.8474 377.078 -30.3135 367.465C-14.9203 364.55 0.431927 361.472 15.7433 358.231Z",
    fill: "white"
  }))), _g72 || (_g72 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask71_1781_645)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.46721 430.776C1.62621 431.141 -0.214786 431.506 -2.05636 431.868C-4.5871 418.984 -7.12086 406.104 -9.65102 393.224C-7.84181 392.868 -6.0326 392.511 -4.22756 392.152C-1.66144 405.026 0.901086 417.901 3.46778 430.779L3.46721 430.776Z",
    fill: "#F3F4F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.98478 429.669C7.14493 430.042 5.30811 430.41 3.4671 430.775C0.900982 417.901 -1.66155 405.026 -4.22824 392.148C-2.41961 391.788 -0.611543 391.424 1.19292 391.061C3.79141 403.93 6.3863 416.8 8.9842 429.666L8.98478 429.669Z",
    fill: "#CD2027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.5002 428.549C12.6609 428.925 10.8247 429.297 8.98484 429.669C6.38635 416.8 3.79146 403.93 1.19356 391.064C3.00162 390.701 4.80551 390.334 6.61242 389.963C9.24269 402.824 11.8699 415.688 14.5002 428.549Z",
    fill: "#F3F4F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.0133 427.414C18.1746 427.794 16.3395 428.173 14.5002 428.549C11.8699 415.689 9.2427 402.824 6.61243 389.964C8.41933 389.593 10.2226 389.222 12.029 388.848C14.6916 401.703 17.3507 414.559 20.0133 427.414Z",
    fill: "#CD2027"
  }))), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M81.5388 343.233C80.546 354.247 79.5017 365.263 78.4065 376.282C77.1078 389.345 75.7318 402.409 74.2869 415.48C67.2126 404.395 60.2073 393.28 53.268 382.139C47.412 372.739 41.6076 363.317 35.8482 353.875C51.1215 350.489 66.3545 346.944 81.5424 343.232L81.5388 343.233Z",
    fill: "#F3F4F5"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M81.5386 343.233C80.6146 353.48 79.6469 363.73 78.6319 373.985C69.7837 376.105 60.9227 378.167 52.0423 380.178C46.6002 371.427 41.1995 362.659 35.8408 353.876C51.1141 350.49 66.3471 346.945 81.535 343.233L81.5386 343.233Z",
    fill: "#265CA9"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "M59.6159 352.513C60.1773 353.437 60.738 354.358 61.303 355.282C62.3697 355.033 63.4328 354.785 64.4989 354.533C63.7819 355.352 63.065 356.172 62.3481 356.991C62.9088 357.912 63.4737 358.836 64.0381 359.756C63.0311 359.342 62.0236 358.925 61.0161 358.507C60.2955 359.327 59.578 360.143 58.8575 360.963C58.9545 359.889 59.0545 358.811 59.1516 357.736C58.144 357.319 57.1401 356.901 56.1362 356.483C57.2035 356.238 58.2666 355.99 59.3333 355.741C59.4303 354.667 59.5267 353.589 59.6237 352.515L59.6159 352.513Z",
    fill: "#F3F4F5"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M70.776 349.883C71.344 350.802 71.9083 351.722 72.4762 352.642C73.5382 352.387 74.6037 352.131 75.6657 351.876C74.9529 352.698 74.2401 353.521 73.5279 354.347C74.0959 355.267 74.6639 356.186 75.2318 357.106C74.2218 356.696 73.2119 356.286 72.2049 355.872C71.4921 356.695 70.7758 357.518 70.0588 358.337C70.1517 357.26 70.2445 356.183 70.3337 355.106C69.3268 354.692 68.3204 354.282 67.3099 353.869C68.3724 353.617 69.4385 353.365 70.5011 353.114C70.5939 352.036 70.6832 350.96 70.7724 349.883L70.776 349.883Z",
    fill: "#F3F4F5"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "M48.4425 355.083C49.0003 356.008 49.5544 356.934 50.1122 357.859C51.1794 357.614 52.2437 357.373 53.311 357.128C52.5898 357.945 51.8687 358.761 51.147 359.574C51.7048 360.499 52.2625 361.424 52.8238 362.348C51.8193 361.926 50.8112 361.505 49.8067 361.084C49.0814 361.897 48.3603 362.713 47.635 363.527C47.7392 362.452 47.8434 361.376 47.9476 360.301C46.9431 359.879 45.9416 359.453 44.9371 359.032C46.005 358.79 47.0692 358.55 48.1371 358.308C48.2413 357.233 48.3419 356.158 48.4425 355.083Z",
    fill: "#F3F4F5"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "M67.6591 361.636C68.2234 362.556 68.7914 363.476 69.3563 364.399C70.426 364.147 71.4958 363.894 72.5649 363.638C71.8485 364.461 71.128 365.281 70.408 366.104C70.976 367.024 71.5403 367.944 72.1083 368.864C71.0941 368.451 70.0842 368.041 69.07 367.628C68.3495 368.448 67.6259 369.273 66.9054 370.093C67.0018 369.015 67.0988 367.941 67.1953 366.863C66.1847 366.45 65.1736 366.033 64.1631 365.619C65.2334 365.37 66.3031 365.118 67.3734 364.868C67.4698 363.791 67.5632 362.717 67.6597 361.639L67.6591 361.636Z",
    fill: "#F3F4F5"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    d: "M56.4338 364.251C56.9951 365.176 57.5565 366.1 58.1172 367.021C59.1881 366.775 60.2584 366.526 61.3287 366.277C60.6082 367.097 59.8834 367.914 59.1587 368.731C59.7201 369.656 60.2844 370.576 60.8457 371.5C59.8346 371.083 58.8235 370.666 57.816 370.249C57.0913 371.066 56.3629 371.883 55.6382 372.7C55.7424 371.625 55.8425 370.547 55.9467 369.471C54.9386 369.05 53.9275 368.633 52.9194 368.212C53.9902 367.967 55.0611 367.721 56.132 367.476C56.2326 366.401 56.3326 365.322 56.4332 364.248L56.4338 364.251Z",
    fill: "#F3F4F5"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask72_1781_645",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 35,
    y: 343,
    width: 47,
    height: 73
  }, _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "M81.5388 343.233C80.546 354.247 79.5017 365.263 78.4065 376.282C77.1078 389.345 75.7318 402.409 74.2869 415.48C67.2126 404.395 60.2073 393.28 53.268 382.139C47.412 372.739 41.6076 363.317 35.8482 353.875C51.1215 350.489 66.3545 346.944 81.5424 343.232L81.5388 343.233Z",
    fill: "white"
  }))), _g73 || (_g73 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask72_1781_645)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M66.0667 417.378C64.2415 417.796 62.4122 418.211 60.5829 418.626C57.6852 405.823 54.7869 393.017 51.8893 380.214C53.6868 379.807 55.4802 379.398 57.2772 378.988C60.2072 391.786 63.1372 404.584 66.0672 417.381L66.0667 417.378Z",
    fill: "#CD2027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.5446 416.116C69.72 416.538 67.8918 416.96 66.0667 417.378C63.1366 404.58 60.2066 391.783 57.2766 378.985C59.07 378.576 60.8664 378.162 62.6586 377.746C65.6204 390.535 68.5822 403.324 71.5446 416.116Z",
    fill: "#F3F4F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.0209 414.843C75.1974 415.272 73.3728 415.694 71.5452 416.12C68.5834 403.331 65.6216 390.542 62.6592 377.749C64.4514 377.333 66.2472 376.916 68.0389 376.496C71.0331 389.279 74.0267 402.06 77.0209 414.843Z",
    fill: "#CD2027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.4906 413.553C80.6678 413.985 78.8444 414.414 77.0209 414.843C74.0267 402.059 71.0331 389.279 68.039 376.495C69.8306 376.075 71.6222 375.655 73.4127 375.228C76.4387 388.003 79.4647 400.778 82.4906 413.553Z",
    fill: "#F3F4F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.9585 412.251C86.1362 412.688 84.314 413.124 82.4905 413.552C79.4646 400.778 76.4386 388.003 73.4126 375.228C75.2037 374.804 76.9942 374.377 78.7847 373.949C81.8424 386.716 84.9008 399.485 87.9585 412.251Z",
    fill: "#CD2027"
  }))), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    d: "M146.772 326.225C146.122 337.262 145.422 348.307 144.67 359.353C143.779 372.447 142.814 385.548 141.777 398.657C134.37 387.795 127.024 376.9 119.747 365.98C113.608 356.766 107.515 347.525 101.472 338.266C116.618 334.414 131.721 330.398 146.772 326.225Z",
    fill: "#F3F4F5"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    d: "M146.772 326.225C146.169 336.495 145.522 346.771 144.828 357.048C136.056 359.436 127.273 361.774 118.468 364.053C112.762 355.473 107.094 346.877 101.471 338.262C116.618 334.41 131.72 330.395 146.771 326.222L146.772 326.225Z",
    fill: "#265CA9"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    d: "M125.17 336.17C125.757 337.076 126.349 337.981 126.94 338.885C127.995 338.606 129.052 338.322 130.106 338.038C129.414 338.88 128.727 339.72 128.035 340.561C128.627 341.466 129.218 342.371 129.809 343.276C128.789 342.893 127.772 342.507 126.751 342.121C126.06 342.962 125.364 343.8 124.669 344.642C124.732 343.562 124.799 342.486 124.862 341.406C123.845 341.019 122.827 340.633 121.81 340.246C122.868 339.966 123.923 339.69 124.981 339.41C125.044 338.33 125.107 337.254 125.17 336.174L125.17 336.17Z",
    fill: "#F3F4F5"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    d: "M136.234 333.197C136.829 334.098 137.424 335.002 138.018 335.903C139.071 335.616 140.124 335.329 141.181 335.041C140.497 335.885 139.81 336.729 139.123 337.573C139.718 338.474 140.316 339.374 140.911 340.278C139.891 339.899 138.868 339.521 137.847 339.139C137.16 339.983 136.469 340.828 135.782 341.669C135.841 340.589 135.9 339.51 135.956 338.432C134.936 338.049 133.919 337.67 132.899 337.288C133.953 337.005 135.01 336.717 136.063 336.434C136.123 335.355 136.178 334.276 136.234 333.197Z",
    fill: "#F3F4F5"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    d: "M114.088 339.084C114.673 339.993 115.257 340.899 115.842 341.808C116.9 341.532 117.955 341.256 119.014 340.979C118.318 341.817 117.626 342.655 116.927 343.49C117.511 344.399 118.099 345.305 118.687 346.21C117.669 345.82 116.651 345.43 115.637 345.039C114.941 345.877 114.242 346.713 113.542 347.548C113.613 346.47 113.683 345.393 113.754 344.312C112.739 343.922 111.721 343.528 110.71 343.133C111.769 342.86 112.824 342.587 113.883 342.311C113.953 341.233 114.02 340.153 114.087 339.076L114.088 339.084Z",
    fill: "#F3F4F5"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    d: "M133.486 345.043C134.081 345.947 134.672 346.848 135.267 347.752C136.328 347.468 137.388 347.18 138.446 346.896C137.755 347.741 137.06 348.582 136.369 349.427C136.964 350.331 137.559 351.232 138.153 352.132C137.129 351.751 136.106 351.373 135.082 350.991C134.387 351.833 133.692 352.678 132.994 353.52C133.057 352.441 133.12 351.361 133.183 350.285C132.159 349.903 131.138 349.517 130.118 349.135C131.179 348.85 132.241 348.57 133.302 348.285C133.364 347.205 133.424 346.126 133.487 345.05L133.486 345.043Z",
    fill: "#F3F4F5"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    d: "M122.356 348C122.944 348.905 123.532 349.811 124.124 350.719C125.185 350.438 126.247 350.157 127.308 349.876C126.614 350.718 125.914 351.557 125.216 352.399C125.807 353.304 126.395 354.209 126.987 355.114C125.962 354.729 124.941 354.343 123.92 353.953C123.221 354.792 122.521 355.631 121.819 356.47C121.889 355.393 121.956 354.312 122.027 353.235C121.005 352.846 119.984 352.46 118.966 352.07C120.029 351.792 121.091 351.515 122.152 351.234C122.219 350.157 122.286 349.077 122.353 348L122.356 348Z",
    fill: "#F3F4F5"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask73_1781_645",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 101,
    y: 326,
    width: 46,
    height: 73
  }, _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    d: "M146.772 326.225C146.122 337.262 145.422 348.307 144.67 359.353C143.779 372.447 142.814 385.548 141.777 398.657C134.37 387.795 127.024 376.9 119.747 365.98C113.608 356.766 107.515 347.525 101.472 338.266C116.618 334.414 131.721 330.398 146.772 326.225Z",
    fill: "white"
  }))), _g74 || (_g74 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask73_1781_645)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M133.631 400.804C131.818 401.279 130.009 401.75 128.196 402.222C124.904 389.512 121.612 376.805 118.317 364.096C120.098 363.633 121.879 363.17 123.656 362.705C126.98 375.406 130.304 388.107 133.631 400.804Z",
    fill: "#CD2027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.064 399.376C137.255 399.854 135.444 400.333 133.631 400.805C130.307 388.103 126.983 375.402 123.656 362.705C125.436 362.238 127.213 361.773 128.993 361.299C132.348 373.992 135.704 386.684 139.064 399.376Z",
    fill: "#F3F4F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.491 397.935C142.683 398.416 140.872 398.898 139.064 399.377C135.708 386.684 132.352 373.991 128.993 361.3C130.773 360.83 132.549 360.357 134.324 359.884C137.712 372.568 141.099 385.251 144.487 397.935L144.491 397.935Z",
    fill: "#CD2027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.915 396.478C148.109 396.967 146.302 397.452 144.491 397.935C141.103 385.251 137.715 372.567 134.328 359.883C136.104 359.41 137.882 358.93 139.657 358.453C143.076 371.128 146.496 383.803 149.915 396.478Z",
    fill: "#F3F4F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.334 395.008C153.528 395.501 151.722 395.989 149.915 396.478C146.496 383.803 143.077 371.128 139.657 358.453C141.432 357.973 143.206 357.493 144.981 357.01C148.432 369.676 151.883 382.342 155.334 395.008Z",
    fill: "#CD2027"
  }))), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    d: "M211.404 307.219C211.1 318.27 210.745 329.33 210.336 340.395C209.853 353.511 209.294 366.632 208.667 379.764C200.928 369.136 193.254 358.474 185.649 347.78C179.23 338.758 172.859 329.71 166.533 320.644C181.543 316.33 196.501 311.855 211.408 307.218L211.404 307.219Z",
    fill: "#F3F4F5"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    d: "M211.405 307.219C211.121 317.504 210.794 327.792 210.42 338.088C201.732 340.746 193.031 343.347 184.307 345.901C178.339 337.503 172.416 329.085 166.529 320.645C181.539 316.331 196.498 311.856 211.405 307.219Z",
    fill: "#265CA9"
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    d: "M190.133 317.823C190.751 318.708 191.369 319.594 191.983 320.481C193.028 320.169 194.073 319.854 195.118 319.539C194.456 320.401 193.791 321.264 193.128 322.123C193.746 323.009 194.364 323.894 194.985 324.779C193.955 324.428 192.924 324.073 191.897 323.718C191.231 324.577 190.565 325.44 189.899 326.3C189.929 325.221 189.962 324.139 189.992 323.061C188.965 322.706 187.934 322.351 186.907 321.995C187.953 321.684 188.998 321.372 190.047 321.06C190.077 319.982 190.107 318.9 190.137 317.822L190.133 317.823Z",
    fill: "#F3F4F5"
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    d: "M201.092 314.512C201.713 315.394 202.334 316.279 202.959 317.16C204.003 316.841 205.047 316.522 206.091 316.2C205.433 317.066 204.775 317.931 204.114 318.797C204.734 319.678 205.36 320.563 205.984 321.444C204.951 321.097 203.921 320.749 202.888 320.402C202.227 321.268 201.565 322.13 200.903 322.996C200.929 321.915 200.955 320.838 200.977 319.757C199.947 319.406 198.918 319.058 197.888 318.707C198.933 318.392 199.977 318.073 201.022 317.755C201.044 316.674 201.07 315.596 201.092 314.516L201.092 314.512Z",
    fill: "#F3F4F5"
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    d: "M179.158 321.076C179.769 321.966 180.384 322.856 180.994 323.743C182.04 323.435 183.09 323.127 184.136 322.815C183.469 323.674 182.799 324.531 182.133 325.39C182.747 326.28 183.362 327.166 183.977 328.056C182.949 327.697 181.921 327.338 180.894 326.979C180.223 327.836 179.553 328.695 178.879 329.552C178.916 328.473 178.954 327.394 178.987 326.315C177.959 325.956 176.935 325.593 175.911 325.233C176.957 324.929 178.007 324.62 179.054 324.316C179.087 323.237 179.125 322.158 179.158 321.079L179.158 321.076Z",
    fill: "#F3F4F5"
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    d: "M198.714 326.439C199.336 327.324 199.957 328.206 200.578 329.091C201.627 328.775 202.678 328.456 203.726 328.136C203.061 329.003 202.395 329.866 201.73 330.732C202.352 331.617 202.976 332.498 203.598 333.384C202.56 333.033 201.527 332.686 200.494 332.336C199.824 333.199 199.159 334.062 198.489 334.926C198.519 333.844 198.549 332.766 198.578 331.684C197.544 331.333 196.511 330.983 195.48 330.628C196.532 330.312 197.581 329.996 198.633 329.68C198.662 328.598 198.689 327.52 198.718 326.439L198.714 326.439Z",
    fill: "#F3F4F5"
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    d: "M187.69 329.734C188.305 330.62 188.923 331.509 189.541 332.395C190.594 332.082 191.643 331.77 192.696 331.458C192.026 332.317 191.356 333.181 190.686 334.041C191.304 334.927 191.923 335.816 192.541 336.702C191.506 336.347 190.472 335.993 189.441 335.638C188.768 336.499 188.098 337.359 187.421 338.22C187.458 337.14 187.491 336.058 187.525 334.979C186.494 334.625 185.463 334.266 184.432 333.908C185.485 333.599 186.538 333.286 187.587 332.978C187.621 331.899 187.654 330.816 187.687 329.738L187.69 329.734Z",
    fill: "#F3F4F5"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask74_1781_645",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 166,
    y: 307,
    width: 46,
    height: 73
  }, _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    d: "M211.404 307.219C211.1 318.27 210.745 329.33 210.336 340.395C209.853 353.511 209.294 366.632 208.667 379.764C200.928 369.136 193.254 358.474 185.649 347.78C179.23 338.758 172.859 329.71 166.533 320.644C181.543 316.33 196.501 311.855 211.408 307.218L211.404 307.219Z",
    fill: "white"
  }))), _g75 || (_g75 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask74_1781_645)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M200.594 382.161C198.802 382.692 197.004 383.217 195.208 383.744C191.524 371.145 187.84 358.542 184.156 345.943C185.921 345.427 187.682 344.909 189.447 344.39C193.163 356.98 196.878 369.571 200.594 382.165L200.594 382.161Z",
    fill: "#CD2027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.974 380.568C204.183 381.103 202.387 381.634 200.594 382.165C196.879 369.574 193.163 356.984 189.447 344.39C191.212 343.871 192.972 343.349 194.732 342.823C198.479 355.405 202.227 367.987 205.974 380.568Z",
    fill: "#F3F4F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.352 378.957C209.561 379.495 207.77 380.033 205.974 380.564C202.226 367.983 198.479 355.401 194.731 342.819C196.491 342.293 198.255 341.767 200.014 341.238C203.794 353.811 207.573 366.384 211.352 378.957Z",
    fill: "#CD2027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.724 377.335C214.934 377.877 213.143 378.419 211.352 378.957C207.573 366.384 203.794 353.811 200.014 341.238C201.774 340.709 203.533 340.179 205.291 339.643C209.102 352.207 212.913 364.768 216.72 377.332L216.724 377.335Z",
    fill: "#F3F4F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.094 375.7C220.305 376.249 218.515 376.794 216.724 377.336C212.913 364.771 209.103 352.211 205.295 339.646C207.054 339.113 208.813 338.577 210.571 338.04C214.413 350.592 218.252 363.148 222.094 375.7Z",
    fill: "#CD2027"
  }))), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    d: "M275.385 286.236C275.424 297.292 275.409 308.356 275.344 319.428C275.268 332.55 275.118 345.686 274.898 358.831C266.837 348.445 258.84 338.024 250.908 327.57C244.215 318.751 237.567 309.906 230.965 301.035C245.825 296.262 260.632 291.328 275.385 286.236Z",
    fill: "#F3F4F5"
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    d: "M275.385 286.236C275.419 296.522 275.413 306.817 275.358 317.121C266.76 320.045 258.146 322.912 249.514 325.732C243.292 317.523 237.11 309.289 230.97 301.038C245.829 296.265 260.636 291.331 275.389 286.239L275.385 286.236Z",
    fill: "#265CA9"
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    d: "M254.461 297.488C255.105 298.355 255.749 299.222 256.394 300.088C257.43 299.741 258.462 299.395 259.499 299.048C258.861 299.929 258.229 300.812 257.588 301.693C258.232 302.56 258.88 303.426 259.524 304.293C258.485 303.973 257.445 303.653 256.404 303.329C255.767 304.209 255.126 305.09 254.486 305.971C254.482 304.891 254.482 303.81 254.479 302.73C253.438 302.406 252.402 302.082 251.365 301.758C252.401 301.415 253.438 301.071 254.471 300.729C254.468 299.648 254.464 298.568 254.457 297.489L254.461 297.488Z",
    fill: "#F3F4F5"
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    d: "M265.307 293.842C265.954 294.705 266.605 295.571 267.253 296.433C268.285 296.083 269.32 295.729 270.352 295.379C269.723 296.266 269.09 297.149 268.457 298.033C269.108 298.895 269.755 299.757 270.406 300.619C269.364 300.303 268.324 299.987 267.281 299.671C266.648 300.554 266.012 301.438 265.379 302.322C265.372 301.242 265.361 300.163 265.353 299.08C264.314 298.763 263.274 298.443 262.234 298.123C263.271 297.776 264.303 297.426 265.335 297.076C265.324 295.997 265.317 294.918 265.305 293.835L265.307 293.842Z",
    fill: "#F3F4F5"
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    d: "M243.594 301.075C244.232 301.947 244.873 302.814 245.514 303.685C246.551 303.345 247.589 303.005 248.625 302.662C247.984 303.54 247.343 304.421 246.702 305.298C247.343 306.169 247.984 307.036 248.625 307.907C247.588 307.579 246.548 307.255 245.51 306.928C244.869 307.805 244.224 308.683 243.579 309.561C243.583 308.48 243.587 307.402 243.587 306.321C242.55 305.993 241.512 305.665 240.478 305.333C241.516 304.997 242.553 304.658 243.59 304.318C243.59 303.237 243.595 302.159 243.595 301.079L243.594 301.075Z",
    fill: "#F3F4F5"
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    d: "M263.301 305.834C263.949 306.7 264.597 307.563 265.244 308.429C266.284 308.078 267.323 307.727 268.362 307.376C267.726 308.26 267.085 309.145 266.449 310.029C267.096 310.891 267.748 311.757 268.399 312.619C267.352 312.303 266.309 311.984 265.266 311.668C264.626 312.553 263.986 313.437 263.341 314.319C263.338 313.239 263.334 312.158 263.33 311.075C262.287 310.755 261.243 310.436 260.2 310.116C261.24 309.769 262.279 309.421 263.319 309.074C263.316 307.993 263.308 306.914 263.301 305.831L263.301 305.834Z",
    fill: "#F3F4F5"
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    d: "M252.391 309.469C253.035 310.336 253.676 311.207 254.321 312.073C255.361 311.729 256.401 311.386 257.445 311.038C256.804 311.919 256.16 312.8 255.516 313.682C256.16 314.548 256.804 315.415 257.448 316.282C256.404 315.959 255.36 315.636 254.32 315.312C253.676 316.194 253.031 317.072 252.383 317.954C252.387 316.872 252.387 315.792 252.387 314.711C251.346 314.387 250.302 314.06 249.261 313.737C250.302 313.396 251.346 313.052 252.386 312.708C252.386 311.627 252.387 310.547 252.387 309.466L252.391 309.469Z",
    fill: "#F3F4F5"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask75_1781_645",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 230,
    y: 286,
    width: 46,
    height: 73
  }, _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    d: "M275.385 286.236C275.424 297.292 275.409 308.356 275.344 319.428C275.268 332.55 275.118 345.686 274.898 358.831C266.837 348.445 258.84 338.024 250.908 327.57C244.215 318.751 237.567 309.906 230.965 301.035C245.825 296.262 260.632 291.328 275.385 286.236Z",
    fill: "white"
  }))), _g76 || (_g76 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask75_1781_645)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M266.908 361.472C265.132 362.056 263.355 362.639 261.578 363.22C257.507 350.738 253.433 338.26 249.363 325.778C251.108 325.206 252.853 324.635 254.601 324.06C258.703 336.529 262.806 349.003 266.912 361.472L266.908 361.472Z",
    fill: "#CD2027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.236 359.714C270.46 360.301 268.684 360.889 266.909 361.476C262.807 349.006 258.704 336.533 254.598 324.064C256.343 323.489 258.088 322.914 259.832 322.336C263.966 334.797 268.099 347.257 272.233 359.718L272.236 359.714Z",
    fill: "#F3F4F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.558 357.939C275.783 358.533 274.012 359.124 272.236 359.711C268.102 347.25 263.968 334.789 259.834 322.328C261.579 321.75 263.322 321.168 265.062 320.586C269.227 333.035 273.393 345.487 277.558 357.935L277.558 357.939Z",
    fill: "#CD2027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.875 356.153C281.104 356.75 279.329 357.345 277.558 357.939C273.393 345.49 269.228 333.038 265.063 320.59C266.806 320.008 268.545 319.423 270.288 318.833C274.485 331.273 278.681 343.713 282.878 356.152L282.875 356.153Z",
    fill: "#F3F4F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.189 354.353C286.419 354.954 284.649 355.555 282.875 356.153C278.678 343.713 274.481 331.274 270.284 318.834C272.023 318.245 273.765 317.656 275.504 317.067C279.732 329.495 283.961 341.926 288.185 354.353L288.189 354.353Z",
    fill: "#CD2027"
  }))), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    d: "M338.667 263.294C339.048 274.343 339.375 285.4 339.652 296.469C339.982 309.588 340.24 322.722 340.426 335.863C332.047 325.732 323.733 315.564 315.483 305.357C308.522 296.747 301.604 288.111 294.734 279.449C309.435 274.219 324.078 268.831 338.663 263.291L338.667 263.294Z",
    fill: "#F3F4F5"
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    d: "M338.667 263.294C339.021 273.576 339.332 283.865 339.596 294.162C331.096 297.347 322.577 300.484 314.034 303.565C307.563 295.551 301.128 287.513 294.735 279.453C309.436 274.222 324.078 268.835 338.663 263.295L338.667 263.294Z",
    fill: "#265CA9"
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    d: "M318.107 275.185C318.778 276.032 319.448 276.876 320.119 277.724C321.142 277.346 322.166 276.968 323.19 276.59C322.582 277.491 321.974 278.393 321.366 279.291C322.037 280.139 322.71 280.982 323.381 281.83C322.331 281.541 321.282 281.252 320.236 280.962C319.624 281.864 319.012 282.763 318.4 283.662C318.364 282.583 318.327 281.501 318.29 280.422C317.244 280.133 316.194 279.84 315.147 279.547C316.172 279.172 317.196 278.798 318.22 278.42C318.183 277.341 318.146 276.259 318.106 275.181L318.107 275.185Z",
    fill: "#F3F4F5"
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    d: "M328.833 271.208C329.507 272.051 330.184 272.894 330.858 273.738C331.881 273.356 332.9 272.972 333.923 272.586C333.319 273.491 332.716 274.395 332.112 275.3C332.789 276.143 333.463 276.987 334.14 277.826C333.088 277.545 332.039 277.259 330.99 276.974C330.383 277.879 329.778 278.78 329.171 279.685C329.131 278.607 329.087 277.526 329.047 276.448C327.997 276.163 326.948 275.877 325.899 275.588C326.922 275.206 327.946 274.828 328.965 274.447C328.922 273.37 328.878 272.289 328.834 271.211L328.833 271.208Z",
    fill: "#F3F4F5"
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    d: "M307.36 279.106C308.028 279.954 308.692 280.807 309.359 281.655C310.384 281.284 311.408 280.91 312.437 280.538C311.825 281.437 311.213 282.336 310.596 283.231C311.264 284.079 311.931 284.931 312.599 285.78C311.552 285.486 310.501 285.19 309.455 284.897C308.838 285.792 308.223 286.692 307.606 287.587C307.577 286.507 307.544 285.428 307.515 284.349C306.468 284.052 305.424 283.754 304.377 283.457C305.403 283.09 306.431 282.719 307.456 282.348C307.423 281.269 307.394 280.189 307.361 279.11L307.36 279.106Z",
    fill: "#F3F4F5"
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    d: "M327.198 283.254C327.872 284.098 328.546 284.942 329.22 285.789C330.247 285.406 331.274 285.024 332.304 284.641C331.697 285.546 331.085 286.449 330.475 287.354C331.148 288.198 331.826 289.041 332.503 289.884C331.45 289.599 330.394 289.315 329.342 289.03C328.73 289.932 328.116 290.838 327.501 291.741C327.464 290.663 327.427 289.58 327.387 288.502C326.334 288.217 325.281 287.929 324.231 287.64C325.259 287.261 326.29 286.882 327.317 286.5C327.277 285.422 327.24 284.34 327.199 283.262L327.198 283.254Z",
    fill: "#F3F4F5"
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    d: "M316.411 287.223C317.082 288.071 317.749 288.919 318.42 289.767C319.452 289.391 320.479 289.012 321.511 288.637C320.896 289.539 320.28 290.439 319.664 291.338C320.335 292.185 321.006 293.033 321.68 293.877C320.626 293.588 319.573 293.296 318.522 293.004C317.907 293.903 317.288 294.802 316.668 295.702C316.635 294.623 316.606 293.54 316.573 292.46C315.522 292.168 314.472 291.875 313.422 291.583C314.454 291.207 315.482 290.835 316.514 290.46C316.481 289.381 316.448 288.301 316.414 287.219L316.411 287.223Z",
    fill: "#F3F4F5"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask76_1781_645",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 294,
    y: 263,
    width: 47,
    height: 73
  }, _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    d: "M338.667 263.294C339.048 274.343 339.375 285.4 339.652 296.469C339.982 309.588 340.24 322.722 340.426 335.863C332.047 325.732 323.733 315.564 315.483 305.357C308.522 296.747 301.604 288.111 294.734 279.449C309.435 274.219 324.078 268.831 338.663 263.291L338.667 263.294Z",
    fill: "white"
  }))), _g77 || (_g77 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask76_1781_645)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M332.527 338.752C330.771 339.392 329.014 340.028 327.253 340.664C322.798 328.314 318.343 315.967 313.887 303.617C315.617 302.993 317.343 302.369 319.067 301.739C323.554 314.077 328.041 326.414 332.527 338.752Z",
    fill: "#CD2027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.796 336.831C336.04 337.474 334.284 338.117 332.527 338.753C328.041 326.415 323.554 314.077 319.067 301.739C320.793 301.112 322.517 300.481 324.242 299.851C328.76 312.176 333.278 324.505 337.792 336.831L337.796 336.831Z",
    fill: "#F3F4F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.059 334.895C341.304 335.542 339.552 336.188 337.796 336.831C333.278 324.505 328.76 312.176 324.246 299.85C325.97 299.22 327.694 298.585 329.418 297.947C333.968 310.264 338.513 322.578 343.063 334.894L343.059 334.895Z",
    fill: "#CD2027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.319 332.945C346.569 333.598 344.814 334.249 343.062 334.895C338.513 322.578 333.967 310.264 329.418 297.948C331.141 297.31 332.861 296.672 334.584 296.031C339.161 308.336 343.742 320.64 348.319 332.941L348.319 332.945Z",
    fill: "#F3F4F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.571 330.981C351.821 331.638 350.07 332.291 348.316 332.945C343.739 320.64 339.158 308.336 334.581 296.035C336.301 295.394 338.024 294.752 339.742 294.108C344.351 306.4 348.963 318.692 353.571 330.985L353.571 330.981Z",
    fill: "#CD2027"
  }))), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    d: "M401.209 238.407C401.931 249.438 402.602 260.481 403.22 271.536C403.957 284.638 404.618 297.755 405.208 310.891C396.522 301.023 387.899 291.115 379.337 281.172C372.112 272.781 364.934 264.364 357.8 255.917C372.333 250.238 386.804 244.399 401.209 238.407Z",
    fill: "#F3F4F5"
  })), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    d: "M401.209 238.407C401.881 248.672 402.507 258.947 403.091 269.233C394.692 272.682 386.273 276.076 377.832 279.421C371.116 271.609 364.438 263.776 357.8 255.917C372.333 250.238 386.804 244.399 401.209 238.407Z",
    fill: "#265CA9"
  })), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    d: "M370.404 255.18C371.094 256.01 371.787 256.839 372.481 257.668C373.494 257.266 374.509 256.86 375.522 256.458C374.938 257.374 374.351 258.291 373.764 259.207C374.458 260.037 375.151 260.862 375.845 261.692C374.788 261.43 373.732 261.167 372.676 260.905C372.089 261.822 371.501 262.735 370.91 263.652C370.848 262.574 370.782 261.497 370.72 260.418C369.667 260.156 368.61 259.89 367.557 259.624C368.573 259.221 369.586 258.822 370.599 258.42C370.533 257.343 370.467 256.265 370.401 255.188L370.404 255.18Z",
    fill: "#F3F4F5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlagLowHigh);
export default __webpack_public_path__ + "static/media/FlagLowHigh.c9c63fdb4f434770690831037cddf568.svg";
export { ForwardRef as ReactComponent };